/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */

// ran this thru claudes code refactoring tool
// ran this thru claudes design

//make top bar in desktop text primary color background also primary color with opacity

// what prompts do i use with claude for other components to match this design?

// Redesign this React component to match our established design system.

// Design language:
// - Aesthetic: Soft & friendly — rounded corners (rounded-2xl, rounded-full), warm and airy
// - Spacing: Generous padding, breathing room between elements
// - Typography: Small-medium text (text-sm, text-xs), font-semibold for labels, uppercase tracking-widest for headings
// - Colors: All colors come from dynamic seller props (sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1) — never hardcode brand colors
// - Backgrounds: Use color + opacity modifiers (e.g. sellerPrimaryColor1 + '12' for tinted fills, + '30' for borders, + '40' for backgrounds)
// - Shadows: shadow-sm on cards, shadow-md on hover, shadow-xl on dropdowns/modals
// - Borders: Always use sellerPrimaryColor1 + '30' or '40' opacity — never solid opaque borders
// - Buttons: Rounded-2xl, solid fill for primary actions; bordered ghost style for secondary actions
// - Hover states: hover:bg-white/60, hover:scale-105, hover:shadow-md — always transition-all duration-200
// - Dropdowns/overlays: rounded-2xl, shadow-xl, border border-white/60, backdrop-blur-sm
// - Badges/counts: Absolute positioned, rounded-full, bg-rose-400 text-white, -top-1.5 -right-1.5
// - Icons: Always paired with text labels or tooltips, sized text-sm to text-xl
// - Active states: Tinted background (primaryColor + '12') rather than just a color change
// - Animations: Smooth transitions — max-h + opacity for reveals, scale for interactive elements
// - Mobile sidebar: duration-300 ease-out, backdrop-blur-[2px] overlay

// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// Give me the complete code with instructions


// [PASTE COMPONENT HERE]

// A few tips for specific component types:

// Cards / product tiles — add "use card pattern: white bg, rounded-2xl, shadow-sm, hover:shadow-md hover:scale-[1.02] transition-all"
// Modals / drawers — add "use frosted glass: bg-white/95 backdrop-blur-sm, rounded-3xl, shadow-2xl"
// Forms / inputs — add "inputs should be rounded-2xl, border with primaryColor+'30', focus ring using primaryColor+'40'"
// Tables / lists — add "rows use hover:bg-primaryColor+'08', active row uses primaryColor+'12' background"
// Toasts / alerts — add "rounded-2xl, shadow-md, soft tinted background matching severity (rose for error, emerald for success)"
// The most important line to always include is:

// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."

// redesign this component to look more elegant and polished
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task




import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { MdEmail, MdOutlineRestaurantMenu } from "react-icons/md";
import { IoMdPhonePortrait, IoIosArrowDown, IoMdLogOut, IoMdLogIn, IoMdClose } from "react-icons/io";
import { AiOutlineDashboard } from "react-icons/ai";
import { FaList, FaUser, FaPhoneAlt } from "react-icons/fa";
import { FaHeart, FaCartShopping, FaPhoneVolume } from "react-icons/fa6";
import { IoChatbubbleEllipsesOutline, IoPhonePortrait } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { CgWebsite } from "react-icons/cg";
import { IoShieldHalfOutline } from "react-icons/io5";
import { BiSolidCoupon } from "react-icons/bi";

import { get_seller_by_frontEndURL } from '../store/reducers/sellerReducer';
import { get_cart_products, get_wishlist_products } from '../store/reducers/cartReducer';
import { get_event_details } from '../store/reducers/eventDetailsReducer';
import { user_reset } from '../store/reducers/authReducer';
import { reset_count } from '../store/reducers/cartReducer';

import { formatPhoneNumber } from 'react-phone-number-input';
import useWindowSize from '../utils/useWindowSize';
import SiteBadge from './SiteBadge';
import GetSellerConfig from './GetSellerConfig';
import Moment from 'moment';

import api from '../api/api';
import toast from 'react-hot-toast';
import config from '../config';

const Header = () => {
    const sellerFrontEndURL = config.STR_FRONTEND_URL;

    //const { seller } = useSelector(state => state.seller);
    const { userInfo } = useSelector(state => state.auth);
    const { cart_product_count, wishlist_count } = useSelector(state => state.cart);
    const { eventDetails } = useSelector(state => state.eventDetails);
    const { categorys, mainIngredients } = useSelector(state => state.home);
    
    let eventDateAndTime = eventDetails?.eventDate + ' ' + eventDetails?.eventStartTime;
    eventDateAndTime = Moment({eventDateAndTime}).format('ddd, MM/DD/yyyy h:mm A')
    
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo, sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, 
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowKosher
    } = GetSellerConfig();

    const { screenWidth } = useWindowSize();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    
    const isCouponValid = Boolean(eventDetails?.coupon) && (!eventDetails?.couponExpirationDate || new Date(eventDetails?.couponExpirationDate) > new Date());
    
    const [showSidebar, setShowSidebar] = useState(true);
    const [categoryShow, setCategoryShow] = useState(true);
    const [mainIngredientShow, setMainIngredientShow] = useState(true);
    const [searchValue, setSearchValue] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('value') ?? '';
    });
    const [category, setCategory] = useState('');
    const [mainIngredient, setMainIngredient] = useState('');

    useEffect(() => {
        dispatch(get_seller_by_frontEndURL(sellerFrontEndURL));
    }, [sellerFrontEndURL, dispatch]);

    useEffect(() => {
        if (userInfo) {
            dispatch(get_cart_products(userInfo.id));
            dispatch(get_wishlist_products(userInfo.id));
            dispatch(get_event_details(userInfo.id));
        }
    }, [userInfo, dispatch]);

    const requireAuth = useCallback((destination) => {
        navigate(userInfo ? destination : '/login');
    }, [userInfo, navigate]);

    const redirect_cart_page = () => requireAuth('/cart');
    const redirect_wishlist_page = () => requireAuth('/customerDashboard/myWishlist');
    const redirect_customerDashboard_page = () => requireAuth('/customerDashboard');
    const redirect_chat_page = () => requireAuth('/customerDashboard/chat/');
    const redirect_eventDetailsCustomerDashboard_page = () => requireAuth('/customerDashboard/eventDetailsCustomerDashboard/');

    const search = useCallback(() => {
        navigate(`/products/search?category=${category}&mainIngredient=${mainIngredient}&value=${searchValue}`);
    }, [category, mainIngredient, searchValue, navigate]);

    const handleSearchChange = (e) => setSearchValue(e.target.value);
    const handleKeyDown = (event) => { if (event.key === 'Enter') search(); };

    const hasSearchMounted = useRef(false);
    useEffect(() => {
        if (!hasSearchMounted.current) { hasSearchMounted.current = true; return; }
        if (searchValue.length >= 3) search();
        else if (searchValue.length === 0) {
            navigate(`/products/search?category=${category}&mainIngredient=${mainIngredient}&value=`);
        }
    }, [searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const logout = async () => {
        try {
            await api.get('/customer/logout');
            localStorage.removeItem('customerToken');
            dispatch(user_reset());
            dispatch(reset_count());
            toast.success('Logout Success');
            navigate('/login');
        } catch (error) {
            console.error(error?.response?.data ?? error);
            toast.error('Logout failed. Please try again.');
        }
    };

    // ── Shared nav link style helper ──────────────────────────────
    const navLinkClass = (path) =>
        `relative px-3 py-1.5 text-[16px] cursor-pointer font-semibold  
         hover:bg-white/60 hover:border-b-2 pl-2 pr-2 pb-1
         ${pathname === path ? 'shadow-sm ' : ''}`;

    return (
        <div id='topMenuDesktop' className='w-full font-sans' style={{ backgroundColor: sellerComponentBackgroundColor}}>

            {/* ══ TOP BAR ═══════════════════════════════════════════════════ */}
            <div
                className='md-lg:hidden w-full'>
                <div className='w-[88%] lg:w-[92%] mx-auto'>
                    <div className='flex w-full justify-between items-center h-[44px] text-[12px] font-medium'>

                        {/* Left: contact info */}
                        <ul className='flex items-center gap-4' style={{ color: sellerColorDark }}>
                            <li className={` ${sellerCompanyEmailAddress !== '' && sellerCompanyEmailAddress !== null && sellerCompanyEmailAddress !== undefined? '' : 'hidden'} 
                                flex items-center gap-1.5 group`}>
                                <span className='bg-white'>
                                    <span
                                        className='flex items-center gap-1 px-2 py-0.5 rounded-md font-semibold border-2'
                                        style={{
                                            borderColor: sellerColorMedium,
                                            backgroundColor: sellerColorLight,
                                        }}>
                                        <MdEmail className='text-[20px] mr-0.5' style={{ color: sellerColorMedium }} />
                                        <span className='leading-tight text-[12px] text-left font-medium'
                                            style={{ color: sellerColorDark}}>
                                            {
                                                <>Email Us<br /><span className='font-bold'>{sellerCompanyEmailAddress}</span></>
                                            }
                                        </span>
                                    </span>  
                                </span>
                            </li>
                            <li className='flex items-center gap-1.5'>
                                <span className='bg-white'>
                                    <span
                                        className='flex items-center gap-1 px-2 py-0.5 rounded-md font-semibold border-2'
                                        style={{
                                            borderColor: sellerColorMedium,
                                            backgroundColor: sellerColorLight,
                                        }}>
                                        <FaPhoneVolume className='text-[16px] mr-0.5' style={{ color: sellerColorMedium}} />
                                        <span className='leading-tight text-[12px] text-left font-medium' style={{ color: sellerColorDark }}>
                                            {
                                                <>Tech Support<br /><span className='font-bold'>718 781-4207</span></>
                                            }
                                        </span>
                                    </span>
                                </span>
                            </li>

                            {sellerStripePaymentMode === 'Test' && (
                                <li className='text-red-500 font-semibold'>
                                    <span className='bg-white'>
                                        <span
                                            className='flex text-red-500 items-center gap-1 px-2 py-0.5 
                                            rounded-md text-[12px] font-semibold border-2 border-red-500 bg-red-100'>
                                            <span className='leading-tight text-left opacity-60  font-medium'>
                                                {
                                                    <>Stripe<br /><span className='opacity-100 font-bold'>{sellerStripePaymentMode} Mode</span></>
                                                }
                                            </span>
                                        </span>
                                    </span>
                                </li>
                            )}
                            {
                                //console.log('sellerOtherWebsiteURL1:', sellerOtherWebsiteURL1)
                            }
                            {sellerOtherWebsiteURL1 !== '' && sellerOtherWebsiteURL1 !== null && sellerOtherWebsiteURL1 !== undefined && (
                                <li>
                                    <span className='bg-white'>
                                        <Link
                                            className='flex underline-offset-2 bg-white/70 hover:underline transition px-2 py-0.5 rounded-md border-2'
                                            target="_blank"
                                            style={{
                                                color: sellerColorDark,
                                                borderColor: sellerColorMedium,
                                            }}
                                            to={sellerOtherWebsiteURL1}>
                                            <CgWebsite className='text-[24px] mt-1 mr-1' style={{ color: sellerColorMedium}} />
                                            <span className='leading-tight text-[12px] text-left font-medium'
                                                style={{ whiteSpace: "pre-wrap",color: sellerColorDark }}>
                                                { sellerOtherWebsiteName1.replace('~', '\n') }
                                            </span>
                                        </Link>
                                    </span>
                                </li>
                            )}
                        </ul>

                        {/* Right: kosher badge + auth */}
                        <div className='flex items-center gap-4'>
                            {/* Kosher pill */}
                            {(sellerCompanyKosherSupervision1 !== 'None' || sellerCompanyKosherSupervision2 !== 'None') && (
                                <span className={`bg-white`}>
                                    <span
                                        className='flex items-center gap-1 px-2 py-0.5 rounded-md font-semibold border-2'
                                        style={{
                                            borderColor: sellerColorMedium,
                                            backgroundColor: sellerColorLight,
                                        }}>
                                        <IoShieldHalfOutline className='text-[22px] mr-0.5' style={{ color: sellerColorMedium}} />
                                        <span className='leading-tight text-[12px] text-left font-medium'
                                            style={{ color: sellerColorDark }}>
                                            {
                                                <>Kosher<br />
                                                <span className='font-bold'>
                                                    <div>
                                                        {sellerCompanyKosherSupervision1 !== 'None' && <span>{sellerCompanyKosherSupervision1}</span>}
                                                        {sellerCompanyKosherSupervision2 !== 'None' && <span>, {sellerCompanyKosherSupervision2}</span>}
                                                    </div>
                                                </span></>
                                            }
                                        </span>
                                    </span>
                                </span>
                            )}

                            {/* Auth area */}
                            {userInfo ? (
                                <div className='flex items-center gap-0.5 border-none border-black'>
                                    {sellerBoolShowSiteChat && (
                                        <button
                                            onClick={redirect_chat_page}
                                            className='flex items-center justify-center w-8 h-8 rounded-md
                                                       hover:bg-white/60 transition-colors'
                                            style={{ color: sellerColorDark }}>
                                            <IoChatbubbleEllipsesOutline className='text-[24px] text-green-600' />
                                        </button>
                                    )}
                                    <button
                                        onClick={redirect_customerDashboard_page}
                                        className='flex items-center justify-center w-8 h-8 rounded-full hover:bg-white/60 transition-colors'
                                        style={{ color: sellerColorDark }}>
                                        <AiOutlineDashboard className='text-[24px] text-green-600' />
                                    </button>
                                        {/* className='text-[13px] pb-0.5 pt-0.5 pl-2 pr-2 text-blue-800 font-semibold 
                                            bg-green-200 border border-blue-800'>
                                      */}
                                    <span className='bg-white'>  
                                        <button
                                            onClick={redirect_eventDetailsCustomerDashboard_page}
                                            className='flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-semibold
                                                    bg-white/70 border-2 hover:bg-white transition-colors'
                                            style={{ 
                                                color: sellerColorDark,
                                                borderColor: sellerColorMedium,
                                            }}>
                                            <FaUser className='text-[20px]' style={{ color: sellerColorMedium}} />
                                            <span className='leading-tight text-left'
                                                style={{ color: sellerColorDark }}>
                                                {eventDetails?.eventName === ''
                                                    ? <>{userInfo?.name}<br /><span className=''>{userInfo?.email}</span></>
                                                    : <>{userInfo?.email}<br /><span className=''>{eventDetails?.eventName}</span></>
                                                }
                                            </span>
                                        </button>
                                    </span>
                                    <button
                                        onClick={logout}
                                        className='flex items-center justify-center w-8 h-8 rounded-full
                                            text-red-400 hover:text-red-600 hover:bg-red-50 transition-colors'>
                                        <IoMdLogOut className='text-[26px] font-bold' />
                                    </button>
                                </div>
                            ) : (
                                <Link
                                    to='/login'
                                    className='flex items-center gap-1.5 px-2 py-1 rounded-md text-[12px] font-semibold
                                        text-green-600 bg-green-100/70 border border-green-600 hover:bg-green-200 transition-colors'>
                                    <IoMdLogIn className='text-[18px]' />
                                    <span>Login</span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ══ LOGO + NAV BAR ════════════════════════════════════════════ */}
            <div className='bg-white/90 backdrop-blur-sm shadow-[0_2px_16px_rgba(0,0,0,0.06)]'>
                <div className='w-[88%] lg:w-[92%] mx-auto'>
                    <div className='flex justify-between items-center h-[72px] md-lg:h-[80px]'>

                        {/* Logo + hamburger */}
                        <div className='flex items-center justify-between gap-4 sm:w-full border-none border-black'>
                            <div>
                                <Link to='/' className='flex-shrink-0 '>
                                    <img
                                        src={sellerCompanyLogo}
                                        alt="company logo"
                                        className={`h-[70px] w-auto object-contain`}
                                    />
                                </Link>
                            </div>
                            {/* Mobile user pill (small screens) caluade align to top */}
                            <div className='hidden sm:flex md:hidden items-center gap-0.5'>
                                {userInfo && (
                                    <div
                                        className='text-[11px] px-2 py-1 rounded-md font-semibold border'
                                        style={{
                                            color: sellerColorDark,
                                            backgroundColor: sellerColorLight,
                                            borderColor: sellerColorMedium,
                                        }}>
                                        <span className='leading-tight text-left'>
                                            {eventDetails?.eventName === ''
                                                ? <>{userInfo?.name}<br /><span className=''>{userInfo?.email}</span></>
                                                : <>{userInfo?.email}<br />{eventDetails?.eventName}
                                                {eventDetails?.eventDate === '' ? '' :
                                                    <span className='opacity-80'>
                                                        <br />{Moment(eventDetails?.eventDate).format('MMM DD, YYYY')}
                                                    </span>
                                                }
                                                </>
                                            }
                                        </span>
                                    </div>
                                )}
                            </div>
                            
                            {/* Hamburger (tablet only) */}
                            <span className='ml-auto'>
                                <button
                                    onClick={() => setShowSidebar(false)}
                                    className='hidden md-lg:flex items-center justify-center w-8 h-8 rounded-md 
                                    border transition-colors hover:bg-gray-50 mb-2.5' 
                                    style={{
                                        borderColor: sellerColorMedium,
                                        color: sellerColorDark
                                    }}>
                                    <FaList size={16} />
                                </button>
                                <div>
                                    {userInfo && (
                                        <div>
                                            <button
                                                onClick={logout}
                                                className='hidden md-lg:flex lg:hidden xl:hidden items-center justify-center
                                                    w-8 h-8 rounded-md text-red-400 hover:text-red-600 hover:bg-red-50 
                                                    transition-colors border border-red-400'>
                                                <IoMdLogOut size={26} />
                                            </button>
                                        </div>
                                    )}
                                    {!userInfo && (
                                        <div>
                                            <Link
                                                to='/login'
                                                className='hidden md-lg:flex lg:hidden xl:hidden items-center justify-center
                                                    w-8 h-8 rounded-md text-green-400 hover:text-green-600 hover:bg-red-50 
                                                    transition-colors border border-green-400'>
                                                <IoMdLogIn size={28} />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </span>
                        </div>

                        {/* Desktop nav links */}
                        <nav className='md-lg:hidden'>
                            <ul className='flex items-center gap-1' 
                                style={{ color: sellerPrimaryColor2 + sellerColorSuffixDark }}>                                
                                {[
                                    { to: '/', label: 'Home' },
                                    { to: '/shops', label: `All ${sellerProductPluralTerm}` },
                                ].map(({ to, label }) => (
                                    <li key={to}>
                                        <Link to={to} className={navLinkClass(to)}
                                            style={{
                                                color: pathname === to ? sellerColorDark : sellerPrimaryColor2 + sellerColorSuffixDark,
                                                borderColor: pathname === to ? sellerColorMedium : sellerPrimaryColor2 + sellerColorSuffixMedium,
                                                backgroundColor: pathname === to ? sellerColorLight : 'transparent'
                                            }}>
                                            {label}
                                        </Link>
                                    </li>
                                ))}
                                {
                                // [
                                //     { to: '/', label: 'Home' },
                                //     { to: '/shops', label: `All ${sellerProductPluralTerm}` },
                                // ].map(({ to, label }) => (
                                //     <li key={to}>
                                //         <Link to={to} className={navLinkClass(to)} >
                                //             {label} redder
                                //         </Link>
                                //     </li>
                                // ))
                                }
                                <li>
                                    <span
                                        onClick={redirect_customerDashboard_page}
                                        className={navLinkClass('/customerDashboard')}
                                        style={{ 
                                            color: pathname === '/customerDashboard' ? sellerColorDark : sellerPrimaryColor2, 
                                            borderColor: pathname === '/customerDashboard' ? sellerColorDark : sellerPrimaryColor2,
                                            backgroundColor: pathname === '/customerDashboard' ? sellerColorLight : 'transparent'
                                        }}>
                                        My Dashboard
                                    </span>
                                </li>
                                {sellerBoolShowGalleryImages && (
                                    <li>
                                        <Link to='/galleryImages' className={navLinkClass('/galleryImages')} 
                                            style={{ 
                                                color: pathname === '/galleryImages' ? sellerColorDark : sellerPrimaryColor2, 
                                                borderColor: pathname === '/galleryImages' ? sellerColorDark : sellerPrimaryColor2,
                                                backgroundColor: pathname === '/galleryImages' ? sellerColorLight : 'transparent'
                                            }}>
                                            Gallery
                                        </Link>
                                    </li>
                                )}
                                <li>
                                    <Link to='/aboutUs' className={navLinkClass('/aboutUs')} 
                                        style={{ 
                                            color: pathname === '/aboutUs' ? sellerColorDark : sellerPrimaryColor2, 
                                            borderColor: pathname === '/aboutUs' ? sellerColorDark : sellerPrimaryColor2,
                                            backgroundColor: pathname === '/aboutUs' ? sellerColorDark + sellerColorSuffixLight : 'transparent'
                                        }}>
                                        About Us
                                    </Link>
                                </li>
                            </ul>
                        </nav>

                        {/* Cart + Wishlist icons */}
                        <div className='md-lg:hidden flex items-center gap-3'>
                            {sellerBoolShowSiteWishList && (
                                <button
                                    onClick={redirect_wishlist_page}
                                    className='relative flex items-center justify-center w-14 h-10 rounded-2xl gap-0.5
                                        transition-all duration-200 hover:scale-105 hover:shadow-md'
                                    style={{ backgroundColor: sellerSecondaryColor1 ?? '#f0f4ff'}}>
                                    <MdOutlineRestaurantMenu className='text-[20px]' style={{ color: sellerColorDark }} />
                                    <FaHeart className='text-[20px]' style={{ color: sellerColorDark }} />
                                    {wishlist_count !== 0 && (
                                        <span className='absolute -top-2 -right-1.5 w-8 h-4 rounded-full bg-rose-400 text-white
                                            text-[12px] font-bold flex items-center justify-center shadow-sm'>
                                            {wishlist_count}
                                        </span>
                                    )}
                                </button>
                            )}
                            <button
                                onClick={redirect_cart_page}
                                className={` ${isCouponValid ? 'w-20' : 'w-14'} 
                                    h-10 relative flex items-center justify-center rounded-2xl gap-0.5
                                    transition-all duration-200 hover:scale-105 hover:shadow-md`}
                                style={{ backgroundColor: sellerSecondaryColor1 ?? '#f0f4ff' }}>
                                <MdOutlineRestaurantMenu className='text-[20px]' style={{ color: sellerColorDark }} />
                                <FaCartShopping className='text-[20px]' style={{ color: sellerColorDark }} />
                                {cart_product_count !== 0 && (
                                    <span className='absolute -top-2 -right-1.5 w-8 h-4 rounded-full bg-rose-400 text-white
                                        text-[12px] font-bold flex items-center justify-center shadow-sm'>
                                        {cart_product_count}
                                    </span>
                                )}
                                <BiSolidCoupon size={24} className={isCouponValid ? '' : 'hidden'} 
                                    style={{ color: sellerColorDark }}/>
                            </button>

                            {/* Mobile logout shortcut */}
                            {userInfo && (
                                <div>
                                    <button
                                        onClick={logout}
                                        className='hidden md-lg:flex lg:hidden xl:hidden items-center justify-center
                                            w-9 h-9 rounded-xl text-red-400 hover:text-red-600 hover:bg-red-50 
                                            transition-colors border border-red-100'>
                                        <IoMdLogOut size={30} />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ══ MOBILE SIDEBAR ════════════════════════════════════════════ */}
            <div className='hidden md-lg:block'>
                {/* Backdrop */}
                <div
                    onClick={() => setShowSidebar(true)}
                    className={`fixed inset-0 bg-black/30 backdrop-blur-[2px] z-20 transition-opacity duration-300
                        ${showSidebar ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
                />

                {/* Drawer */}
                <aside
                    className={`w-[300px] z-[9999] fixed top-0 h-screen overflow-y-auto
                        bg-white/95 backdrop-blur-sm shadow-2xl
                        transition-all duration-300 ease-out
                        ${showSidebar ? '-left-[300px]' : 'left-0'}`}>
                    <div className='flex flex-col gap-5 py-7 px-7'>

                        {/* Sidebar header */}
                        <div className='flex justify-between items-start'>
                            <Link to='/' onClick={() => setShowSidebar(true)}>
                                <img src={sellerCompanyLogo} alt="company logo" className='h-12 w-auto object-contain' />
                            </Link>
                            <button
                                onClick={() => setShowSidebar(true)}
                                className='flex items-center justify-center w-8 h-8 rounded-xl border text-gray-400
                                    hover:text-red-500 hover:border-red-200 transition-colors'
                                style={{ borderColor: '#e5e7eb' }}>
                                <IoMdClose className='text-xl' />
                            </button>
                        </div>

                        {/* Kosher badge */}
                        {(sellerCompanyKosherSupervision1 !== 'None' || sellerCompanyKosherSupervision2 !== 'None') && (
                            <div
                                className='inline-flex items-center gap-0.5 px-2 py-1.5 rounded-md text-xs font-semibold w-fit border-2'
                                style={{
                                    color: sellerColorDark,
                                    backgroundColor: sellerColorLight,
                                    borderColor: sellerColorMedium,
                                }}>
                                <IoShieldHalfOutline size={16} />
                                Kosher ·
                                {sellerCompanyKosherSupervision1 !== 'None' && <span>{sellerCompanyKosherSupervision1}</span>}
                                {sellerCompanyKosherSupervision2 !== 'None' && <span>{sellerCompanyKosherSupervision2}</span>}
                            </div>
                        )}

                        {/* Auth section 
                        <div
                            className='text-[11px] px-2 py-1 rounded-md font-semibold border'
                            style={{
                                color: sellerColorDark,
                                backgroundColor: sellerSecondaryColor1 + sellerColorSuffixLight,
                                borderColor: sellerColorMedium
                            }}>
                        */}
                        {userInfo ? (
                            <div className='flex flex-col gap-1.5'>
                                <div
                                    className='flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-semibold leading-5 border'
                                    style={{
                                        backgroundColor: sellerColorLight,
                                        borderColor: sellerColorMedium,
                                    }}>
                                    <FaUser className='text-[20px]' style={{ color: sellerColorMedium }} />
                                    <span className='leading-tight text-left' style={{ color: sellerColorDark }}>
                                        {eventDetails?.eventName === ''
                                            ? <>{userInfo?.name}<br /><span className=''>{userInfo?.email}</span></>
                                            : <>{userInfo?.email}<br /><span className=''>{eventDetails?.eventName}</span></>
                                        }
                                    </span>
                                </div>
                                <div className='flex gap-1'>
                                    {sellerBoolShowSiteChat && (
                                        <button
                                            onClick={redirect_chat_page}
                                            className='flex-1 flex items-center justify-center gap-0.5 px-1.5 py-1 rounded-md
                                                text-xs font-semibold border transition-colors hover:bg-gray-50'
                                            style={{ color: sellerColorDark, 
                                            borderColor: sellerColorMedium }}>
                                            <IoChatbubbleEllipsesOutline size={18} 
                                                style={{ color: sellerColorDark }} /> Chat
                                        </button>
                                    )}
                                    <button
                                        onClick={redirect_customerDashboard_page}
                                        className='flex-1 flex items-center justify-center gap-0.5 px-1.5 py-1 rounded-md
                                            text-xs font-semibold border transition-colors hover:bg-gray-50'
                                        style={{ 
                                            color: sellerColorDark, 
                                            borderColor: sellerColorMedium 
                                        }}>
                                        <AiOutlineDashboard  size={20} style={{ color: sellerColorDark }} /> Dashboard
                                    </button>
                                    <button
                                        onClick={logout}
                                        className='flex items-center justify-center gap-0.5 px-1.5 py-1 rounded-md
                                            text-xs font-semibold text-red-400 border border-red-400 hover:bg-red-50 transition-colors'>
                                        <IoMdLogOut  size={20} /> Logout
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <Link
                                    to='/login'
                                    className='flex items-center justify-center gap-0.5 py-2.5 rounded-md text-md font-semibold
                                        transition-colors text-green-600 bg-green-100/70 border border-green-600 
                                        hover:bg-green-200'>
                                    <IoMdLogIn size={20} />
                                    Login
                                </Link>
                            </div>
                        )}

                        {/* Tagline pill */}
                        {sellerTaglineTop1 && (
                            <div
                                className='text-center py-2 px-4 rounded-md text-xs font-bold uppercase tracking-widest'
                                style={{
                                    backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark ?? '#f0f4ff',
                                    color: sellerColorDark,
                                }}>
                                {sellerTaglineTop1}
                            </div>
                        )}

                        {/* Nav links 
                        ...(sellerOtherWebsiteURL1 !== '' ? [{ to: sellerOtherWebsiteURL1, label: sellerOtherWebsiteName1, external: true }] : []),
                                    
                        */}
                        <nav>
                            <ul className='flex flex-col gap-0.5 text-sm font-semibold'>
                                {[
                                    { to: '/', label: 'Home' },
                                    { to: '/shops', label: `All ${sellerProductPluralTerm}` },
                                    { to: '/customerDashboard', label: 'My Dashboard' },
                                    ...(sellerBoolShowGalleryImages ? [{ to: '/galleryImages', label: 'Gallery' }] : []),
                                    { to: '/aboutUs', label: 'About Us' },
                                    
                                ].map(({ to, label, external }) => (
                                    <li key={to}>
                                        {external ? (
                                            <Link
                                                to={to}
                                                target="_blank"
                                                className='block px-3 py-2.5 rounded-md transition-colors hover:bg-gray-50'
                                                style={{ color: sellerPrimaryColor2 + sellerColorSuffixDark }}>
                                                {label}
                                            </Link>
                                        ) : (
                                            <Link
                                                to={to}
                                                onClick={() => setShowSidebar(true)}
                                                className='block px-3 py-2.5 rounded-xl transition-colors'
                                                style={{
                                                    color: pathname === to ? sellerColorDark : sellerPrimaryColor2,
                                                    backgroundColor: pathname === to ? (sellerColorLight) : 'transparent',
                                                }}>
                                                {label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        {/* Divider */}
                        <div className='border-t border-gray-300' />

                        {/* Contact block */}
                        <div className='flex flex-col gap-3 text-sm' 
                            style={{ color: sellerPrimaryColor2 + sellerColorSuffixDark }}>
                            <div className='flex items-center gap-3'>
                                <div
                                    className='w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0'
                                    style={{ backgroundColor: sellerSecondaryColor1 ?? '#f0f4ff' }}>
                                    <FaPhoneVolume className='text-[14px]' 
                                        style={{ color: sellerColorMedium }} />
                                </div>
                                <div>
                                    <div className='font-semibold'>{formatPhoneNumber(sellerCompanyPhoneNumber)}</div>
                                    <div className='text-xs'>Call Us!</div>
                                </div>
                            </div>
                            <div className='flex items-center gap-3'>
                                <div
                                    className='w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0'
                                    style={{ backgroundColor: sellerSecondaryColor1 ?? '#f0f4ff' }}>
                                    <MdEmail className='text-[18px]' style={{ color: sellerColorMedium }} />
                                </div>
                                <div>
                                    <div className='font-semibold'>{sellerCompanyEmailAddress}</div>
                                    <div className='text-xs'>Email Us!</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>

            {/* ══ SEARCH + CATEGORY STRIP ════════════════════════════════════ */}
            <div
                className=''
                style={{
                    backgroundColor: sellerSecondaryColor1 + sellerColorSuffixLight ? sellerSecondaryColor1 + sellerColorSuffixLight : '#f8faff',
                }}>
                <div className='w-[88%] lg:w-[92%] mx-auto py-3'>
                    
                    {/* Taglines (desktop) */}
                    {
                    // sellerTaglineTop1 && (
                    //     <div
                    //         className='sm:hidden text-center text-sm font-bold uppercase tracking-[0.15em] mb-2.5 opacity-80'
                    //         style={{ color: sellerPrimaryColor1 }}>
                    //         {sellerTaglineTop1}
                    //     </div>
                    // )
                    }
                    {/* ── Tagline 2 ── */}
                    {sellerTaglineTop2 && (
                        <div
                            className='sm:hidden m-2 text-center text-2xl font-bold uppercase tracking-widest'
                            style={{ color: sellerColorDark }}>
                            {sellerTaglineTop2}
                        </div>
                    )}
                    
                    <div className='flex w-full flex-wrap gap-3 md-lg:gap-4 border-none border-black'>

                        {/* ── Category dropdowns (left col) ── gap 2 */}
                        <div className='w-3/12 md-lg:w-full flex flex-col gap-1.5 sm:gap-1'>
                            {/* Categories */}
                            <div className='relative pt-1.5'>
                                <button
                                    onClick={() => setCategoryShow(!categoryShow)}
                                    className='w-full h-10 flex items-center justify-between px-2.5 rounded-xl
                                        text-[15px] font-semibold text-white transition-all'
                                    style={{ backgroundColor: sellerColorDark }}>
                                    <div className='flex items-center gap-2'>
                                        <FaList className='text-[18px]' />
                                        <span>All Categories</span>
                                    </div>
                                    <IoIosArrowDown className={`text-[24px] transition-transform duration-200 ${categoryShow ? '' : 'rotate-180'}`} />
                                </button>

                                <div
                                    className={`${categoryShow ? 'max-h-0 opacity-0' : 'max-h-[280px] opacity-100'}
                                        overflow-y-auto transition-all duration-300 ease-out
                                        absolute z-[99999] w-full top-[calc(100%+6px)]
                                        rounded-xl shadow-xl border border-white/60 backdrop-blur-sm`}
                                    style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark ?? '#f8faff' }}>
                                    <ul className='py-2 px-2'>
                                        {categorys.map((c, i) => (
                                            <li key={i}>
                                                <Link
                                                    onClick={() => setCategoryShow(true)}
                                                    to={`/productsCategory?category=${c.name}`}
                                                    className='flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm
                                                        hover:bg-white/70 transition-colors'
                                                    style={{ color: sellerColorDark }}>
                                                    <img src={c.image} alt="" className='w-7 h-7 rounded-full object-cover flex-shrink-0 shadow-sm' />
                                                    {c.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {/* Main Ingredients */}
                            <div className='relative'>
                                <button
                                    onClick={() => setMainIngredientShow(!mainIngredientShow)}
                                    className='w-full h-10 flex items-center justify-between px-2.5 rounded-xl
                                        text-[15px] font-semibold text-white transition-all'
                                    style={{ backgroundColor: sellerColorDark }}>
                                    <div className='flex items-center gap-2'>
                                        <FaList className='text-[18px]' />
                                        <span>All {sellerMainIngredientPluralTerm}</span>
                                    </div>
                                    <IoIosArrowDown className={`text-[24px] transition-transform duration-200 ${mainIngredientShow ? '' : 'rotate-180'}`} />
                                </button>

                                <div
                                    className={`${mainIngredientShow ? 'max-h-0 opacity-0' : 'max-h-[280px] opacity-100'}
                                        overflow-y-auto transition-all duration-300 ease-out
                                        absolute z-[99990] w-full top-[calc(100%+6px)]
                                        rounded-xl shadow-xl border border-white/60 backdrop-blur-sm`}
                                    style={{ backgroundColor: sellerSecondaryColor1 ?? '#f8faff' }}>
                                    <ul className='py-2 px-2'>
                                        {mainIngredients.map((c, i) => (
                                            <li key={i}>
                                                <Link
                                                    onClick={() => setMainIngredientShow(true)}
                                                    to={`/productsMainIngredient?mainIngredient=${c.name}`}
                                                    className='flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm
                                                        hover:bg-white/70 transition-colors'
                                                    style={{ color: sellerColorDark }}>
                                                    <img src={c.image} alt="" className='w-7 h-7 rounded-full object-cover flex-shrink-0 shadow-sm' />
                                                    {c.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* ── Search + marketing (right col) ── */}
                        <div className='w-6/12 pl-2 md-lg:pl-0 md-lg:w-full flex flex-col gap-1.5 border-none border-green-600'>

                            {/* Tagline pill (mobile) */}
                            {sellerTaglineTop1 && (
                                <div className='bg-white rounded-xl'>
                                    <div
                                        className='sm:inline-flex hidden text-center items-center justify-center px-3 py-2 mb-0.5 
                                            rounded-xl border text-[17px] font-bold uppercase tracking-widest'
                                        style={{
                                            backgroundColor: sellerColorLight,
                                            color: sellerColorDark,
                                            borderColor: sellerColorDark,
                                        }}>
                                        {sellerTaglineTop1}
                                    </div>
                                </div>
                            )}

                            {/* Search bar */}
                            <div className='flex items-center w-full h-10 rounded-xl overflow-hidden border bg-white'
                                style={{ borderColor: sellerColorDark }}>
                                <input
                                    id='searchBox'
                                    onChange={handleSearchChange}
                                    value={searchValue}
                                    onKeyDown={handleKeyDown}
                                    type="text"
                                    placeholder='Search the menu…'
                                    className='flex-1 px-4 h-full bg-transparent outline-none text-md'
                                    style={{ color: sellerColorDark }}
                                />
                                <button
                                    onClick={search}
                                    className='flex items-center gap-1 sm:gap-0.5 px-5 sm:px-1 h-full text-md 
                                        sm:text-[12px] font-semibold text-white transition-opacity hover:opacity-70 
                                        flex-shrink-0'
                                    style={{ backgroundColor: sellerColorDark }}>
                                    <FiSearch className='text-[18px] sm:text-[15px]' />
                                    <span>Search</span>
                                </button>
                            </div>

                            {/* Marketing line */}
                            {sellerMarketingLine1 && (
                                <div className='bg-white p-1 rounded-xl border border-black '
                                    style={{ borderColor: sellerColorDark }}>
                                    <div className='flex items-center mt-0 gap-1.5 border-none border-black'>
                                        <SiteBadge iconType={'Menu'} iconSize={'28'} badgeSize={'32'} />
                                        <p className='text-[12px] sm:text-[11px] font-medium leading-snug' 
                                            style={{ color: sellerColorDark }}>
                                            {sellerMarketingLine1}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='w-2/12 sm:w-9/12 flex min-h-full items-start justify-start justify-items-start 
                            border-none border-green-600'>
                            <div className='w-full grid grid-cols-1 sm:grid-cols-2 gap-1.5 
                                pt-1.5 sm:pt-0 xs:pt-0'>
                                {/* ── Holiday CTA ── */}
                                {sellerHolidayHeader && sellerHolidayHeader !== 'None' && (
                                    <div className='w-full border-none border-black'>
                                        <div className='flex w-full justify-center border-none border-black'>
                                            <span className='bg-white rounded-xl'>
                                                <a
                                                    href={`/shops/${sellerHolidayHeader}`}
                                                    className='flex items-center justify-center gap-0.5 
                                                        h-[42px] w-[140px] sm:h-[38px] sm:w-[124px] xs:h-[38px] xs:w-[124px] 
                                                        px-0 py-0 rounded-xl text-xs font-semibold
                                                        bg-white/70 border-2 hover:bg-white transition-colors
                                                        hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]'
                                                        style={{ 
                                                            color: sellerColorDark, 
                                                            borderColor: sellerColorMedium,
                                                            backgroundColor: sellerColorLight 
                                                        }}>
                                                    <MdOutlineRestaurantMenu className='text-[30px] sm:text-[26px] xs:text-[26px]' 
                                                        style={{ color: sellerColorMedium }}/>
                                                    <span className='leading-tight text-left text-[13px] sm:text-[11px]'>
                                                        <>Check Out Our<br /><span>{sellerHolidayHeader} Menu</span></>
                                                    </span>
                                                </a>
                                            </span>
                                        </div>        
                                    </div>
                                )}
                                <div>
                                    {/* ── Custom Menu ── customMenuProducts */}
                                    {eventDetails?.customMenuProducts && eventDetails?.customMenuProducts !== '[]' && (
                                    <div className='w-full border-none border-black'>
                                        <div className='flex w-full justify-center '>
                                            <span className='bg-white rounded-xl'>
                                                <a
                                                    href={'/customerDashboard/myCustomMenu'}
                                                    className='flex items-center justify-center gap-0.5  
                                                        h-[42px] w-[140px] sm:h-[38px] sm:w-[124px] xs:h-[38px] xs:w-[124px] 
                                                        px-0 py-0 rounded-xl text-xs font-semibold
                                                        bg-white/70 border-2 hover:bg-white transition-colors 
                                                        hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]'
                                                        style={{ 
                                                            color: sellerColorDark, 
                                                            borderColor: sellerColorMedium,
                                                            backgroundColor: sellerColorLight
                                                        }}>
                                                    <MdOutlineRestaurantMenu className='text-[30px] sm:text-[26px] xs:text-[26px]'  
                                                        style={{ color: sellerColorMedium }}/>
                                                    <span className='leading-tight text-left text-[13px] sm:text-[11px]'>
                                                        <>Go To My<br />Custom Menu</>
                                                    </span>
                                                </a>
                                            </span>
                                        </div>        
                                    </div>
                                    )}
                                </div> 
                            </div>
                        </div>
                    </div>

                    {/* ── personal tagline (desktop) ── */}
                    {personalServiceTagLine && personalServiceTagLine !== '' && (
                        <div
                            className='sm:hidden mt-1 text-center text-sm font-semibold uppercase tracking-widest opacity-75'
                            style={{ color: sellerColorDark }}>
                            {personalServiceTagLine}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;





//before claude redesign
// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { MdEmail, MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoMdPhonePortrait, IoIosArrowDown, IoMdLogOut, IoMdLogIn, IoMdArrowDropdown, IoMdClose } from "react-icons/io";
// import { AiOutlineDashboard } from "react-icons/ai";
// import { FaFacebookF, FaList, FaLock, FaUser, FaGithub, FaLinkedin, FaPhoneAlt } from "react-icons/fa";
// import { FaTwitter, FaHeart, FaCartShopping } from "react-icons/fa6";
// import { IoChatbubbleEllipsesOutline } from "react-icons/io5";

// import { get_seller_by_frontEndURL } from '../store/reducers/sellerReducer';
// import { get_cart_products, get_wishlist_products } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { user_reset } from '../store/reducers/authReducer';
// import { reset_count } from '../store/reducers/cartReducer';

// import useWindowSize from '../utils/useWindowSize';
// import SkeletonWithImage from './SkeletonWithImage';

// import api from '../api/api';
// import toast from 'react-hot-toast';
// import config from '../config';

// const Header = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL;

//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);
//     const { cart_product_count, wishlist_count } = useSelector(state => state.cart);
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { categorys, mainIngredients } = useSelector(state => state.home);

//     const sellerId = seller._id;
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerPrimaryColor2 = seller?.frontEndPrimaryColor2;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;
//     const sellerShopName = seller?.shopName;
//     const sellerShopNameSlug = seller?.shopNameSlug;
//     const sellerStripePaymentMode = seller?.stripePaymentMode;
//     const sellerOtherWebsiteURL1 = seller?.otherWebsiteURL1;
//     const sellerOtherWebsiteName1 = seller?.otherWebsiteName1;
//     const sellerProductPluralTerm = seller?.productPluralTerm;
//     const sellerCompanyPhoneNumber = seller?.phoneNumber;
//     const sellerCompanyLogo = seller?.logoImage;
//     const sellerCompanyEmailAddress = seller?.emailAddress;
//     const sellerCompanyKosherSupervision1 = seller?.kosherSupervision1;
//     const sellerCompanyKosherSupervision2 = seller?.kosherSupervision2;
//     const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm;
//     const sellerTaglineTop1 = seller?.taglineTop1;
//     const sellerTaglineTop2 = seller?.taglineTop2;
//     const personalServiceTagLine = seller?.personalServiceTagLine;
//     const sellerMarketingLine1 = seller?.marketingLine1;
//     const sellerHolidayHeader = seller?.holidayHeader;

//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show';
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show';
//     const sellerBoolShowGalleryImages = seller?.isVisibleGalleryImages === 'Show';

//     const { screenWidth, screenHeight } = useWindowSize();
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { pathname } = useLocation();

//     const [showSidebar, setShowSidebar] = useState(true);
//     const [categoryShow, setCategoryShow] = useState(true);
//     const [mainIngredientShow, setMainIngredientShow] = useState(true);
//     // BEFORE
//     //const [searchValue, setSearchValue] = useState('');
//     // AFTER
//     const [searchValue, setSearchValue] = useState(() => {
//         const params = new URLSearchParams(window.location.search);
//         return params.get('value') ?? '';
//     });
//     const [category, setCategory] = useState('');
//     const [mainIngredient, setMainIngredient] = useState('');
    
//     useEffect(() => {
//         dispatch(get_seller_by_frontEndURL(sellerFrontEndURL));
//     }, [sellerFrontEndURL, dispatch]);

//     useEffect(() => {
//         if (userInfo) {
//             dispatch(get_cart_products(userInfo.id));
//             dispatch(get_wishlist_products(userInfo.id));
//             dispatch(get_event_details(userInfo.id));
//         }
//     }, [userInfo, dispatch]);

//     // BUG FIX: Single helper replaces 5 near-identical redirect functions
//     const requireAuth = useCallback((destination) => {
//         navigate(userInfo ? destination : '/login');
//     }, [userInfo, navigate]);

//     const redirect_cart_page = () => requireAuth('/cart');
//     const redirect_wishlist_page = () => requireAuth('/customerDashboard/myWishlist');
//     const redirect_customerDashboard_page = () => requireAuth('/customerDashboard');
//     const redirect_chat_page = () => requireAuth('/customerDashboard/chat/');
//     const redirect_eventDetailsCustomerDashboard_page = () => requireAuth('/customerDashboard/eventDetailsCustomerDashboard/');

//     const search = useCallback(() => {
//         // BUG FIX: was using && (logical AND) instead of & (query param separator)
//         navigate(`/products/search?category=${category}&mainIngredient=${mainIngredient}&value=${searchValue}`);
//     }, [category, mainIngredient, searchValue, navigate]);

    
//     // // BUG FIX: Allow clearing search (removed truthy guard `if (val)`)
//     // const handleSearchChange = (e) => {
//     //     setSearchValue(e.target.value);
//     // };

//     // ─── ONLY CHANGED BLOCK ─────────────────────────────────────
//     // Replace your existing handleSearchChange and handleKeyDown
//     // and add the new useEffect right after them.
//     // Everything else in the file stays exactly the same.
//     // ────────────────────────────────────────────────────────────

//     const handleSearchChange = (e) => {
//         setSearchValue(e.target.value);
//     };

//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter') search();
//     };

//     const hasSearchMounted = useRef(false);

//     useEffect(() => {
//         if (!hasSearchMounted.current) {
//             hasSearchMounted.current = true;
//             return; // skip on initial mount
//         }
//         if (searchValue.length >= 3) {
//             search();
//         } else if (searchValue.length === 0) {
//             navigate(`/products/search?category=${category}&mainIngredient=${mainIngredient}&value=`);
//         }
//     }, [searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

//     const logout = async () => {
//         try {
//             // BUG FIX: toast should fire AFTER successful API call, not before
//             await api.get('/customer/logout');
//             localStorage.removeItem('customerToken');
//             dispatch(user_reset());
//             dispatch(reset_count());
//             toast.success('Logout Success');
//             navigate('/login');
//         } catch (error) {
//             console.error(error?.response?.data ?? error);
//             toast.error('Logout failed. Please try again.');
//         }
//     };

//     return (
//         <div id='topMenuDesktop' className='w-full bg-white'>
//             {/* ── Top Bar ── */}
//             <div className='header-top bg-[#caddff] md-lg:hidden'>
//                 <div className='w-[85%] lg:w-[90%] mx-auto'>
//                     <div className='flex w-full justify-between items-center h-[50px] font-semibold text-sm'>
//                         <ul className='flex justify-start items-center gap-6' style={{ color: sellerPrimaryColor2 }}>
//                             <li className='flex relative justify-center items-center gap-2 after:absolute
//                                 after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]'>
//                                 <span><MdEmail /></span>
//                                 <span>{sellerCompanyEmailAddress}</span>
//                             </li>
//                             <li className='hidden relative justify-center items-center gap-2 after:absolute
//                                 after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]'>
//                                 <span><IoMdPhonePortrait /></span>
//                                 <span>{sellerCompanyPhoneNumber}<br />Menu Questions</span>
//                             </li>
//                             <li className='flex relative justify-center items-center gap-2'>
//                                 <span><IoMdPhonePortrait /></span>
//                                 <span>718 781-4207<br />Tech Support</span>
//                             </li>
//                             <li className={sellerStripePaymentMode === 'Test' ? 'text-red-500' : 'hidden'}>
//                                 <span>
//                                     <div>Stripe Payment</div>
//                                     <div>Mode {sellerStripePaymentMode}</div>
//                                 </span>
//                             </li>
//                             <li className={sellerOtherWebsiteURL1 === '' ? 'hidden' : ''}>
//                                 <Link className='hover:underline' target="_blank" to={sellerOtherWebsiteURL1}>
//                                     {sellerOtherWebsiteName1}
//                                 </Link>
//                             </li>
//                         </ul>

//                         <div className='flex justify-center items-center gap-10'>
//                             <div className={`flex cursor-pointer justify-center items-center gap-1 relative
//                                 after:h-[18px] after:-right-[16px] after:absolute before:absolute before:h-[18px]
//                                 after:bg-[#afafaf] before:bg-[#afafaf] after:w-[1px] before:w-[1px] before:-left-[20px]`}
//                                 style={{ color: sellerPrimaryColor2 }}>
//                                 Kosher:
//                                 <span className={sellerCompanyKosherSupervision1 === 'None' ? 'hidden' : ''}>{sellerCompanyKosherSupervision1}</span>
//                                 <span className={sellerCompanyKosherSupervision2 === 'None' ? 'hidden' : ''}>{sellerCompanyKosherSupervision2}</span>
//                             </div>

//                             {userInfo ? (
//                                 <span className='flex cursor-pointer justify-center items-center gap-1'>
//                                     <span
//                                         className={`${sellerBoolShowSiteChat ? '' : 'hidden'}
//                                         border rounded-md text-green-500 hover:bg-green-200 hover:border-green-500 cursor-pointer`}
//                                         onClick={redirect_chat_page}>
//                                         <IoChatbubbleEllipsesOutline className='text-[36px]' />
//                                     </span>
//                                     <span
//                                         onClick={redirect_customerDashboard_page}
//                                         className='border rounded-md text-green-500 hover:bg-green-200 hover:border-green-500 cursor-pointer'>
//                                         <AiOutlineDashboard className='text-[36px]' />
//                                     </span>
//                                     {eventDetails?.eventName === '' ? (
//                                         <span
//                                             onClick={redirect_eventDetailsCustomerDashboard_page}
//                                             className='text-[13px] pb-0.5 pt-0.5 pl-2 pr-2 text-blue-800 font-semibold bg-green-200 border border-blue-800'>
//                                             {userInfo?.name}<br />{userInfo?.email}
//                                         </span>
//                                     ) : (
//                                         <span
//                                             onClick={redirect_eventDetailsCustomerDashboard_page}
//                                             className='text-[13px] pb-0.5 pt-0.5 pl-2 pr-2 text-blue-800 font-semibold bg-green-200 border border-blue-800 leading-4'>
//                                             {userInfo?.email}<br />{eventDetails?.eventName}
//                                         </span>
//                                     )}
//                                     <IoMdLogOut onClick={logout} className='text-red-500 hover:text-red-800 text-[36px]' />
//                                 </span>
//                             ) : (
//                                 <Link to='/login' className='flex cursor-pointer justify-center items-center gap-0.5 text-green-600'>
//                                     <span><IoMdLogIn size={20} /></span>
//                                     <span>Login</span>
//                                 </Link>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ── Logo + Nav ── */}
//             <div className='w-white'>
//                 <div className='w-[85%] lg:w-[90%] mx-auto'>
//                     <div className='h-[80px] md-lg:h-[130px] flex justify-between items-center flex-wrap'>
//                         <div className='md-lg:w-full w-3/12 md-lg:pt-4 border-none'>
//                             <div className='flex justify-between items-center'>
//                                 <Link to='/'>
//                                     <img src={sellerCompanyLogo} alt="company logo" className='' />
//                                 </Link>
//                                 <div
//                                     onClick={() => setShowSidebar(false)}
//                                     className='justify-center items-center w-[34px] h-[34px] rounded-lg cursor-pointer
//                                     lg:hidden md-lg:flex xl:hidden hidden border'
//                                     style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                     <span><FaList /></span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className='sm:inline-block md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                             {userInfo && (
//                                 <span className='mb-4 gap-1'>
//                                     <div className='text-[13px] p-1 pr-2 pl-2 text-blue-800 font-semibold bg-green-200 border border-blue-800'>
//                                         {userInfo?.email} {eventDetails?.eventName}
//                                     </div>
//                                 </span>
//                             )}
//                         </div>

//                         {userInfo && (
//                             <div className='sm:inline-block border p-1 rounded-lg md-lg:hidden lg:flex xl:hidden 2xl:hidden 4k:hidden items-left justify-left'
//                                 style={{ borderColor: sellerPrimaryColor1 }}>
//                                 <IoMdLogOut onClick={logout} className='text-red-600 text-[24px]' />
//                             </div>
//                         )}

//                         <div className='md:lg:w-[98%] w-7/12 border-none justify-items-center'>
//                             <div className='pl-1 pr-1 border-none'>
//                                 <div id='ULMenuTop' className='border-none text-[17px]'>
//                                     <ul className='flex w-full border-none gap-4 text-nowrap font-bold md-lg:hidden'>
//                                         {[
//                                             { to: '/', label: 'Home' },
//                                             { to: '/shops', label: `All ${sellerProductPluralTerm}` },
//                                         ].map(({ to, label }) => (
//                                             <li key={to}>
//                                                 <Link to={to} className='hover:border-b-2 pl-2 pr-2 pb-1'
//                                                     style={{
//                                                         color: pathname === to ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                         borderColor: pathname === to ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                     }}>
//                                                     {label}
//                                                 </Link>
//                                             </li>
//                                         ))}
//                                         <li>
//                                             <span
//                                                 onClick={redirect_customerDashboard_page}
//                                                 className='hover:border-b-2 pl-2 pr-2 pb-1 cursor-pointer'
//                                                 style={{
//                                                     color: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                     borderColor: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                 }}>
//                                                 My Dashboard
//                                             </span>
//                                         </li>
//                                         <li className={sellerBoolShowGalleryImages ? '' : 'hidden'}>
//                                             <Link to='/galleryImages' className='hover:border-b-2 pl-2 pr-2 pb-1'
//                                                 style={{
//                                                     color: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                     borderColor: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                 }}>
//                                                 Gallery
//                                             </Link>
//                                         </li>
//                                         <li>
//                                             <Link to='/aboutUs' className='hover:border-b-2 pl-2 pr-2 pb-1'
//                                                 style={{
//                                                     color: pathname === '/aboutUs' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                     borderColor: pathname === '/aboutUs' ? sellerPrimaryColor1 : sellerPrimaryColor2,
//                                                 }}>
//                                                 About Us
//                                             </Link>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className='md:lg:w-full w-2/12 border-none'>
//                             <div className='flex md-lg:hidden justify-center items-center'>
//                                 <div className='flex justify-center gap-5' style={{ borderColor: sellerPrimaryColor1 }}>
//                                     <div
//                                         onClick={redirect_wishlist_page}
//                                         style={{ backgroundColor: sellerSecondaryColor1 }}
//                                         className={`${sellerBoolShowSiteWishList ? '' : 'hidden'}
//                                         relative flex justify-center items-center cursor-pointer rounded-full w-[65px] h-[35px]`}>
//                                         <span className='text-xl pr-1' style={{ color: sellerPrimaryColor1 }}><MdOutlineRestaurantMenu /></span>
//                                         <span className='text-xl' style={{ color: sellerPrimaryColor1 }}><FaHeart /></span>
//                                         {wishlist_count !== 0 && (
//                                             <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex
//                                                 justify-center items-center -top-[8px] -right-[16px]'>
//                                                 {wishlist_count}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div
//                                         onClick={redirect_cart_page}
//                                         className='relative flex justify-center items-center cursor-pointer whitespace-nowrap
//                                         w-[65px] h-[35px] rounded-full'
//                                         style={{ backgroundColor: sellerSecondaryColor1 }}>
//                                         <span className='text-xl pr-1' style={{ color: sellerPrimaryColor1 }}><MdOutlineRestaurantMenu /></span>
//                                         <span className='text-xl' style={{ color: sellerPrimaryColor1 }}><FaCartShopping /></span>
//                                         {cart_product_count !== 0 && (
//                                             <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex
//                                                 justify-center items-center -top-[8px] -right-[16px]'>
//                                                 {cart_product_count}
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ── Mobile Sidebar ── */}
//             <div className='hidden md-lg:block'>
//                 <div
//                     onClick={() => setShowSidebar(true)}
//                     className={`fixed transition-all duration-2000 ease-in-out delay-200
//                         ${showSidebar ? 'invisible' : 'visible'} hidden md-lg:block w-screen h-screen
//                         bg-[rgba(0,0,0,0.5)] top-0 left-0 z-20`}>
//                 </div>
//                 <div
//                     id='sideMenuMobile'
//                     className={`w-[300px] z-[9999] transition-all duration-2000 ease-in-out delay-200 fixed
//                         ${showSidebar ? '-left-[300px]' : 'left-0 top-0'} overflow-y-auto bg-white h-screen py-6 px-8`}>
//                     <div className='flex justify-start flex-col gap-6'>
//                         <table className='w-full'>
//                             <tbody>
//                                 <tr>
//                                     <td>
//                                         <Link to='/'>
//                                             <img className='mb-1' src={sellerCompanyLogo} alt="company logo" />
//                                         </Link>
//                                     </td>
//                                     <td valign='top'>
//                                         <div
//                                             onClick={() => setShowSidebar(!showSidebar)}
//                                             className='justify-center items-center w-[30px] h-[30px] rounded-lg
//                                             cursor-pointer lg:hidden md-lg:flex xl:hidden hidden border text-red-600 text-[18px]'
//                                             style={{ borderColor: sellerPrimaryColor1 }}>
//                                             <span><IoMdClose /></span>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>

//                         <div className='flex justify-start items-center gap-7'>
//                             <div className={`flex cursor-pointer text-sm justify-center items-center gap-1 relative after:h-[18px]
//                                 after:-right-[10px] after:absolute before:absolute before:h-[10px] text-slate-800 font-bold
//                                 after:bg-[#afafaf] before:bg-[#afafaf] after:w-[1px] before:-left-[18px]`}>
//                                 <div className='font-bold' style={{ color: sellerPrimaryColor1 }}>
//                                     <div>Kosher</div>
//                                     <span className={sellerCompanyKosherSupervision1 === 'None' ? 'hidden' : 'font-bold'}>{sellerCompanyKosherSupervision1}</span>
//                                     <span className={sellerCompanyKosherSupervision2 === 'None' ? 'hidden' : 'font-bold'}> {sellerCompanyKosherSupervision2}</span>
//                                 </div>
//                             </div>

//                             {userInfo ? (
//                                 <div className='grid grid-cols-3 gap-2 border-none'>
//                                     <div className='border p-1 rounded-lg' style={{ borderColor: sellerPrimaryColor1 }}>
//                                         <IoChatbubbleEllipsesOutline
//                                             className={`${sellerBoolShowSiteChat ? '' : 'hidden'} text-green-500 bg-white text-[28px]`}
//                                             onClick={redirect_chat_page} />
//                                     </div>
//                                     <div className='border p-1 rounded-lg' style={{ borderColor: sellerPrimaryColor1 }}>
//                                         <AiOutlineDashboard onClick={redirect_customerDashboard_page} className='text-green-500 text-[28px]' />
//                                     </div>
//                                     <div className='border p-1 rounded-lg' style={{ borderColor: sellerPrimaryColor1 }}>
//                                         <IoMdLogOut onClick={logout} className='text-red-600 text-[28px]' />
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <Link to='/login' className='flex cursor-pointer justify-center items-center gap-0.5 text-sm text-green-600'>
//                                     <span><IoMdLogIn size={20} /></span>
//                                     <span>Login</span>
//                                 </Link>
//                             )}
//                         </div>

//                         {userInfo && (
//                             <div className='flex tracking-widest border-none' style={{ color: sellerPrimaryColor1 }}>
//                                 {eventDetails?.eventName === '' ? (
//                                     <span className='w-full text-[13px] p-1 text-blue-800 font-semibold bg-green-200 border border-blue-800'>
//                                         <div className='pl-2 pt-1'>{userInfo?.name}</div>
//                                         <div className='pl-2 pb-1'>{userInfo?.email}</div>
//                                     </span>
//                                 ) : (
//                                     <div className='w-full text-[13px] text-blue-800 font-semibold bg-green-200 border border-blue-800'>
//                                         <div className='pl-2 pt-1'>{userInfo?.email}</div>
//                                         <div className='pl-2 pb-1'>{eventDetails?.eventName}</div>
//                                     </div>
//                                 )}
//                             </div>
//                         )}

//                         <div
//                             className='w-full p-1 flex justify-center items-center uppercase font-bold tracking-widest border'
//                             style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                             {sellerTaglineTop1}
//                         </div>

//                         <ul className='flex flex-col justify-start items-start text-sm font-bold uppercase'>
//                             <li>
//                                 <Link to='/' className='p-2 block' style={{ color: pathname === '/' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     Home
//                                 </Link>
//                             </li>
//                             <li>
//                                 <Link to='/shops' className='p-2 block' style={{ color: pathname === '/shops' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     All {sellerProductPluralTerm}
//                                 </Link>
//                             </li>
//                             <li>
//                                 <span onClick={redirect_customerDashboard_page} className='p-2 block cursor-pointer'
//                                     style={{ color: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     My Dashboard
//                                 </span>
//                             </li>
//                             <li className={sellerBoolShowGalleryImages ? '' : 'hidden'}>
//                                 <Link to='/galleryImages' className='p-2 block'
//                                     style={{ color: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     Gallery
//                                 </Link>
//                             </li>
//                             {/* BUG FIX: was checking '/about' instead of '/aboutUs' */}
//                             <li>
//                                 <Link to='/aboutUs' className='p-2 block'
//                                     style={{ color: pathname === '/aboutUs' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     About Us
//                                 </Link>
//                             </li>
//                             <li className={sellerOtherWebsiteURL1 === '' ? 'hidden' : ''}>
//                                 <Link className='p-2 block' target="_blank" to={sellerOtherWebsiteURL1}>
//                                     {sellerOtherWebsiteName1}
//                                 </Link>
//                             </li>
//                         </ul>

//                         <div className='w-full flex justify-end md-lg:justify-start gap-3 items-center'>
//                             <div className='w-[48px] h-[48px] rounded-full flex bg-[#f5f5f5] justify-center items-center'>
//                                 <span style={{ color: sellerPrimaryColor2 }}><FaPhoneAlt /></span>
//                             </div>
//                             <div className='flex justify-end flex-col gap-1'>
//                                 <h2 className='text-sm font-medium' style={{ color: sellerPrimaryColor2 }}>{sellerCompanyPhoneNumber}</h2>
//                                 <span className='text-xs' style={{ color: sellerPrimaryColor2 }}>Call Us!!</span>
//                             </div>
//                         </div>

//                         <ul className='flex flex-col justify-start items-start gap-3' style={{ color: sellerPrimaryColor2 }}>
//                             <li className='flex justify-start items-center gap-2 text-sm'>
//                                 <span><MdEmail /></span>
//                                 <span>{sellerCompanyEmailAddress}</span>
//                             </li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>

//             {/* ── Search + Category Row ── */}
//             <div className='w-[85%] lg:w-[90%] mx-auto'>
//                 <div className='flex w-full flex-wrap md-lg:gap-8'>
//                     <div className='w-3/12 md-lg:w-full'>
//                         <div className='bg-white relative'>
//                             <div
//                                 onClick={() => setCategoryShow(!categoryShow)}
//                                 className='h-[40px] flex justify-center md-lg:justify-between md-lg:px-6 items-center gap-3
//                                 font-bold text-md cursor-pointer text-white'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <div className='flex justify-center items-center gap-2'>
//                                     <span><FaList /></span>
//                                     <span>All Categories</span>
//                                 </div>
//                                 <span className='pt-1'><IoIosArrowDown /></span>
//                             </div>
//                             <div
//                                 className={`${categoryShow ? 'h-0' : 'h-[300px]'}
//                                 overflow-y-scroll transition-all md-lg:relative duration-500 absolute z-[99999] w-full border-x`}
//                                 style={{ backgroundColor: sellerSecondaryColor1 }}>
//                                 <ul className='py-2 font-medium'>
//                                     {categorys.map((c, i) => (
//                                         <li key={i} className='flex justify-start items-center gap-2 px-[24px] py-[6px]'>
//                                             <img src={c.image} alt="" className='w-[30px] h-[30px] rounded-full overflow-hidden' />
//                                             <Link
//                                                 onClick={() => setCategoryShow(true)}
//                                                 to={`/productsCategory?category=${c.name}`}
//                                                 className='text-sm block'
//                                                 style={{ color: sellerPrimaryColor1 }}>
//                                                 {c.name}
//                                             </Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>

//                             <div
//                                 onClick={() => setMainIngredientShow(!mainIngredientShow)}
//                                 className='h-[40px] mt-1 flex justify-center md-lg:justify-between md-lg:px-6 items-center gap-3
//                                 font-bold text-md cursor-pointer text-white'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <div className='flex justify-center items-center gap-2'>
//                                     <span><FaList /></span>
//                                     <span>All {sellerMainIngredientPluralTerm}</span>
//                                 </div>
//                                 <span className='pt-1'><IoIosArrowDown /></span>
//                             </div>
//                             {/* BUG FIX: Removed duplicate <img> tag inside mainIngredients.map */}
//                             <div
//                                 className={`${mainIngredientShow ? 'h-0' : 'h-[300px]'}
//                                 overflow-y-scroll transition-all md-lg:relative duration-500 absolute z-[99990] w-full border-x`}
//                                 style={{ backgroundColor: sellerSecondaryColor1 }}>
//                                 <ul className='py-2 font-medium'>
//                                     {mainIngredients.map((c, i) => (
//                                         <li key={i} className='flex justify-start items-center gap-2 px-[24px] py-[6px]'>
//                                             <img src={c.image} alt="" className='w-[30px] h-[30px] rounded-full overflow-hidden' />
//                                             <Link
//                                                 onClick={() => setMainIngredientShow(true)}
//                                                 to={`/productsMainIngredient?mainIngredient=${c.name}`}
//                                                 className='text-sm block'
//                                                 style={{ color: sellerPrimaryColor1 }}>
//                                                 {c.name}
//                                             </Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>

//                     <div id='MiddleSecondRowSectionGood' className='w-9/12 pl-3 md-lg:pl-0 md-lg:w-full'>
//                         <div className='flex flex-wrap w-full justify-between items-center md-lg:gap-6'>
//                             <div className='w-9/12 md-lg:w-full'>
//                                 <div
//                                     className='sm:inline-block md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden
//                                     border w-full h-[54px] mb-1 text-lg flex text-center items-center justify-center uppercase font-bold tracking-widest'
//                                     style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                     {sellerTaglineTop1}
//                                 </div>
//                                 <div
//                                     className='sm:hidden border w-full h-[40px] mb-1 p-2 text-lg flex border-[#dbf3ed]
//                                     text-center items-center justify-center uppercase font-bold tracking-widest'
//                                     style={{ color: sellerPrimaryColor1 }}>
//                                     {sellerTaglineTop1}
//                                 </div>

//                                 <div className='flex border-none h-[40px] items-center relative gap-6'>
//                                     {/* BUG FIX: was `if (val)` — now allows clearing the field */}
//                                     <input id='searchBox'
//                                         onChange={handleSearchChange}
//                                         value={searchValue}
//                                         onKeyDown={handleKeyDown}
//                                         type="text"
//                                         placeholder='Menu Search'
//                                         style={{ color: sellerPrimaryColor1 }}
//                                         className='w-full border rounded-l-lg relative bg-transparent text-slate-500 outline-0 px-3 h-full' />
//                                     <button
//                                         onClick={search}
//                                         className='right-0 absolute rounded-r-lg px-2 w-[80px] h-full font-semibold uppercase text-white'
//                                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                         Search
//                                     </button>
//                                 </div>
//                             </div>

//                             <div className='w-3/12 block md-lg:hidden pl-3 md-lg:w-full md-lg:pl-0'>
//                                 <div className='w-full border-none flex justify-end md-lg:justify-start gap-1 items-center'>
//                                     <div>
//                                         <div className='w-[70px] h-[70px] rounded-full flex justify-center items-center border-none'
//                                             style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1 }}>
//                                             <span><MdOutlineRestaurantMenu className='text-[46px]' /></span>
//                                         </div>
//                                     </div>
//                                     <div className='flex justify-end flex-col gap-1'>
//                                         <div className='text-[12px] border-none leading-5' style={{ color: sellerPrimaryColor1 }}>
//                                             {sellerMarketingLine1}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div
//                         className='w-full sm:hidden p-2 text-2xl my-1 mb-2 flex justify-center items-center
//                         uppercase text-center font-bold tracking-widest border border-[#dbf3ed]'
//                         style={{ color: sellerPrimaryColor1 }}>
//                         {sellerTaglineTop2}
//                     </div>

//                     <div
//                         className={`${personalServiceTagLine === '' ? 'hidden' : ''}
//                         w-full sm:hidden p-1 text-md my-1 mb-2 flex justify-center items-center
//                         uppercase text-center font-semibold tracking-widest border border-[#dbf3ed]`}
//                         style={{ color: sellerPrimaryColor1 }}>
//                         {personalServiceTagLine}
//                     </div>

//                     <div className={`${sellerHolidayHeader === 'None' ? 'hidden' : ''} w-full text-center items-center justify-center justify-items-center`}>
//                         <a
//                             className='2xs:text-[16px] xs:text-[16px] sm:text-[16px] md:text-md md-lg:text-md
//                             lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl 4xl:text-2xl
//                             flex cursor-pointer hover:underline text-white rounded-xl border py-1 px-3
//                             justify-center items-center'
//                             href={`/shops/${sellerHolidayHeader}`}
//                             rel="noreferrer"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}>
//                             <MdOutlineRestaurantMenu className='mr-1 inline-block' /> Check Out Our {sellerHolidayHeader} Menu
//                         </a>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Header;







//my original code
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { MdEmail, MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoMdPhonePortrait, IoIosArrowDown, IoMdLogOut, IoMdLogIn, IoMdArrowDropdown, IoMdClose } from "react-icons/io";
// import { AiOutlineDashboard } from "react-icons/ai";
// import { FaFacebookF, FaList, FaLock, FaUser, FaGithub, FaLinkedin, FaPhoneAlt } from "react-icons/fa";
// import { FaTwitter, FaHeart, FaCartShopping } from "react-icons/fa6";
// import { IoChatbubbleEllipsesOutline } from "react-icons/io5";

// import { get_seller_by_frontEndURL } from '../store/reducers/sellerReducer';
// import { get_cart_products, get_wishlist_products } from '../store/reducers/cartReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { user_reset } from '../store/reducers/authReducer'
// import { reset_count } from '../store/reducers/cartReducer'

// import useWindowSize from '../utils/useWindowSize';
// import SkeletonWithImage from './SkeletonWithImage';

// import api from '../api/api';
// import toast from 'react-hot-toast';

// import config from '../config';
// import io from 'socket.io-client'

// const Header = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL 

//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth) 
//     const { cart_product_count, wishlist_count } = useSelector(state => state.cart) 
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { categorys, mainIngredients } = useSelector(state => state.home) 
                
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1
//     let sellerShopName = seller?.shopName
//     //console.log('sellerShopName in header', sellerShopName)
//     const sellerShopNameSlug = seller?.shopNameSlug
//     const sellerStripePaymentMode = seller?.stripePaymentMode
//     const sellerOtherWebsiteURL1 = seller?.otherWebsiteURL1
//     const sellerOtherWebsiteName1 = seller?.otherWebsiteName1
                
//     const sellerProductPluralTerm = seller?.productPluralTerm
//     const sellerCompanyPhoneNumber = seller?.phoneNumber
//     const sellerCompanyLogo = seller?.logoImage
//     const sellerCompanyEmailAddress = seller?.emailAddress
//     const sellerCompanyKosherSupervision1 = seller?.kosherSupervision1
//     const sellerCompanyKosherSupervision2 = seller?.kosherSupervision2
//     const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm
//     const sellerTaglineTop1 = seller?.taglineTop1
//     const sellerTaglineTop2 = seller?.taglineTop2
//     const personalServiceTagLine = seller?.personalServiceTagLine
//     const sellerMarketingLine1  = seller?.marketingLine1
//     const sellerHolidayHeader = seller?.holidayHeader

//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist  === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show' ? true : false
//     const sellerBoolShowGalleryImages = seller?.isVisibleGalleryImages === 'Show' ? true : false

//     const { screenWidth, screenHeight } = useWindowSize();
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
    
//     useEffect(() => {
//         dispatch(get_seller_by_frontEndURL(sellerFrontEndURL))
//     },[sellerFrontEndURL])
    
//     useEffect(() => {
//         if (userInfo) {
//             dispatch(get_cart_products(userInfo.id))    
//             dispatch(get_wishlist_products(userInfo.id))
//             dispatch(get_event_details(userInfo.id))
//         }
//     },[userInfo])

//     const redirect_cart_page = () => {
//         if (userInfo) {
//             navigate('/cart')
//         } else {
//             navigate('/login')
//         }
//     }

//     const redirect_wishlist_page = () => {
//         if (userInfo) {
//             navigate('/customerDashboard/myWishlist')
//         } else {
//             navigate('/login')
//         }
//     }

//     const redirect_customerDashboard_page = () => {
//         if (userInfo) {
//             navigate('/customerDashboard')
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const redirect_chat_page = () => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const redirect_eventDetailsCustomerDashboard_page = () => {
//         if (userInfo) {
//             navigate(`/customerDashboard/eventDetailsCustomerDashboard/`)
//         } else {
//             navigate('/login')
//         }
//     }
//     const {pathname} = useLocation()
    
//     const [showSidebar, setShowSidebar] = useState(true);
//     const [categoryShow, setCategoryShow] = useState(true);
//     const [mainIngredientShow, setMainIngredientShow] = useState(true);
    
//     const [searchValue, setSearchValue] = useState('')
//     const [category, setCategory] = useState('')
//     const [mainIngredient, setMainIngredient] = useState('')
    
//     const searchValueLocal =(val) => {
//         if (val){
//             setSearchValue(val)
//         }
//     }

//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter') {
//             search()
//         }
//     };

//     const search = () => {
//         //navigate(`/products/search?category=${category}&&value=${searchValue}`)
//         navigate(`/products/search?category=${category}&&mainIngredient=${mainIngredient}&&value=${searchValue}`)
//     }
    
//     const logout = async () => {
//         try {
//             toast.success('Logout Success')
//             const {data} = await api.get('/customer/logout')
//             localStorage.removeItem('customerToken')
//             dispatch(user_reset())
//             dispatch(reset_count())
//             navigate('/login')
//         } catch (error) {
//             console.log(error.response.data)
//         }
//     }

//     return (      
//         <div id='topMenuDesktop' className='w-full bg-white'>
//             {/* setPageTitle() */}
//             <div className='header-top bg-[#caddff] md-lg:hidden'>
//                 <div className='w-[85%] lg:w-[90%] mx-auto'>
//                     <div className='flex w-full justify-between items-center h-[50px] font-semibold text-sm'>
//                         <ul className='flex justify-start items-center gap-6'
//                             style={{color:sellerPrimaryColor2}}>
//                             <li className='flex relative justify-center items-center gap-2 after:absolute 
//                                 after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]'>
//                                 <span><MdEmail /></span>
//                                 <span>{sellerCompanyEmailAddress}</span>
//                             </li>
//                             {/* flex */}
//                             <li className='hidden relative justify-center items-center gap-2 after:absolute 
//                                 after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]'>
//                                 <span><IoMdPhonePortrait  /></span>
//                                 <span>{sellerCompanyPhoneNumber}<br/>Menu Questions</span>
//                             </li>
//                             <li className='flex relative justify-center items-center gap-2'>
//                                 <span><IoMdPhonePortrait  /></span>
//                                 <span>718 781-4207<br/>Tech Support</span>
//                             </li>
//                             <li className={` ${sellerStripePaymentMode === 'Test' ? 'text-red-500' : 'hidden' }  `}>
//                                 <span>
//                                     <div>Stripe Payment</div>
//                                     <div>Mode {sellerStripePaymentMode}</div>
//                                 </span>
//                             </li>
//                             <li className={` ${sellerOtherWebsiteURL1 === '' ? 'hidden' : '' }  `}>
//                                 <span>
//                                     <Link className='hover:underline' target="_blank" to={`${sellerOtherWebsiteURL1}`}>
//                                         {sellerOtherWebsiteName1} 
//                                     </Link>
//                                 </span>
//                                 <div className='hidden'>
//                                     {/*faviconUrl*/}
//                                 </div>
//                             </li>
//                         </ul>
//                         <div>
//                             <div className='flex justify-center items-center gap-10'>
//                                 <div className='hidden justify-center items-center gap-4 text-black'>
//                                     <a href="#"><FaFacebookF /></a>
//                                     <a href="#"><FaTwitter /></a>
//                                     <a href="#"><FaLinkedin /></a>
//                                     <a href="#"><FaGithub /></a> 
//                                 </div>
//                                 <div className={`flex cursor-pointer justify-center items-center gap-1 relative after:h-[18px]  
//                                     after:-right-[16px] after:absolute before:absolute before:h-[18px]  
//                                     after:bg-[#afafaf] before:bg-[#afafaf] after:w-[1px] before:w-[1px] before:-left-[20px]`}
//                                     style={{color:sellerPrimaryColor2}}>
//                                     Kosher: 
//                                     <span className={`${sellerCompanyKosherSupervision1 === 'None' ? 'hidden' : ''} `}>{sellerCompanyKosherSupervision1}</span>
//                                     <span className={`${sellerCompanyKosherSupervision2 === 'None' ? 'hidden' : ''} `}>{sellerCompanyKosherSupervision2}</span>
//                                 </div>  
//                                 <div className='group hidden cursor-pointer text-sm justify-center items-center gap-1 relative after:h-[18px]  
//                                     after:-right-[16px] after:absolute before:absolute before:h-[18px] after:bg-[#afafaf] before:bg-[#afafaf] 
//                                     after:w-[1px] before:w-[1px] before:-left-[20px]'>
//                                     <img src={sellerFrontEndURL + `/images/language.png`} alt="" />
//                                     <span><IoMdArrowDropdown /></span>
//                                     <ul className='flex absolute invisible transition-all top-12 rounded-sm duration-200 p-2 w-[100px] flex-col gap-3 group-hover:visible group-hover:top-6 
//                                         text-white group-hover:bg-black z-10'>
//                                         <li>Hindi</li>
//                                         <li>English</li>
//                                     </ul>
//                                 </div>    
//                                 {
//                                     userInfo ?
//                                         <span className='flex cursor-pointer justify-center items-center gap-1'>
//                                             <FaUser className='hidden text-green-500 text-[18px]'/>
//                                             <span className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                                                 border rounded-md text-green-500 hover:bg-green-200 hover:border-green-500 cursor-pointer`} 
//                                                 onClick={redirect_chat_page}>
//                                                 <IoChatbubbleEllipsesOutline className=' text-[36px]'/> 
//                                             </span>
//                                             <span onClick={redirect_customerDashboard_page} 
//                                                 className='border rounded-md text-green-500 hover:bg-green-200 hover:border-green-500 cursor-pointer justify-center items-center gap-1'>
//                                                 <AiOutlineDashboard className=' text-[36px]'/>
//                                             </span>
//                                             {   
//                                                 eventDetails?.eventName === '' ?
//                                                 <span onClick={redirect_eventDetailsCustomerDashboard_page} 
//                                                     className='text-[13px] pb-0.5 pt-0.5 pl-2 pr-2 text-blue-800 font-semibold 
//                                                     bg-green-200 border border-blue-800'>
//                                                     {userInfo?.name}<br />{userInfo?.email}
//                                                 </span>
//                                                 :
//                                                 <span onClick={redirect_eventDetailsCustomerDashboard_page} 
//                                                     className='text-[13px] pb-0.5 pt-0.5 pl-2 pr-2 text-blue-800 font-semibold 
//                                                     bg-green-200 border border-blue-800 leading-4 '>
//                                                     {userInfo?.email}<br />{eventDetails?.eventName}
//                                                 </span>
//                                             }
//                                             <IoMdLogOut onClick={logout} className='text-red-500 hover:text-red-800 text-[36px]' />
//                                         </span>
//                                         :       
//                                          <Link to='/login' className='flex cursor-pointer justify-center items-center gap-0.5 
//                                             text-green-600'>    
//                                             <span><IoMdLogIn size={20} /></span>
//                                             <span>Login</span>
//                                          </Link>
//                                 }
//                                 {
//                                     !userInfo ? '' : ''
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className='w-white'>
//                 <div className='w-[85%] lg:w-[90%] mx-auto'>
//                     <div className='h-[80px] md-lg:h-[130px] flex justify-between items-center flex-wrap'>
//                         <div className='md-lg:w-full w-3/12 md-lg:pt-4 border-none'>
//                             <div className='flex justify-between items-center'>
//                                 <Link to='/'>
//                                     <img src={sellerCompanyLogo} alt="mylogopng" className='' />
//                                 </Link>
//                                 <div onClick={() => setShowSidebar(false)} 
//                                     className='justify-center items-center w-[34px] h-[34px] rounded-lg 
//                                     cursor-pointer lg:hidden md-lg:flex xl:hidden hidden border'
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}    >
//                                     <span><FaList/></span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className='sm:inline-block md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                             { 
//                                 userInfo ?
//                                 <span className='mb-4 gap-1'>
//                                     <div 
//                                         className='text-[13px] p-1 pr-2 pl-2 text-blue-800 font-semibold 
//                                         bg-green-200 border border-blue-800'>
//                                         {userInfo?.email} {eventDetails?.eventName}
//                                     </div>
//                                 </span>
//                                 :
//                                 ''
//                             } 
//                         </div>
//                         {
//                             userInfo ? 
//                             <div className='sm:inline-block border p-1 rounded-lg md-lg:hidden lg:flex xl:hidden 2xl:hidden 4k:hidden items-left justify-left'
//                                 style={{ borderColor:sellerPrimaryColor1}}>
//                                 <IoMdLogOut onClick={logout} className='text-red-600 text-[24px]' />
//                             </div>
//                             : 
//                             ''
//                         }
//                         <div className='md:lg:w-[98%] w-7/12 border-none justify-items-center'>
//                             <div className='pl-1 pr-1 border-none '>
//                                 <table className= 'hidden w-full border-none'>
//                                     <tbody>
//                                         <tr>
//                                             <td className='border w-1/5 text-sm' align='center'>Home</td>
//                                             <td className='border w-1/5' align='center'>All {sellerProductPluralTerm}</td>
//                                             <td className='border w-1/5' align='center'>My Dashboard</td>
//                                             <td className='border w-1/5' align='center'>About Us</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                                 <div id='ULMenuTop' className='border-none text-[17px]'>
//                                     <ul className='flex w-full border-none gap-4 text-nowrap font-bold md-lg:hidden'>
//                                         <li className='' id='menuBar' name='menuBar'>
//                                             <Link to='/' className='hover:border-b-2 pl-2 pr-2 pb-1' 
//                                                 style={{color: pathname === '/' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                 borderColor: pathname === '/' ? sellerPrimaryColor1 : sellerPrimaryColor2}}>                                            
//                                                 Home
//                                             </Link>
//                                         </li>
//                                         <li className=''>
//                                             <Link to='/shops' className='hover:border-b-2 pl-2 pr-2 pb-1' 
//                                                 style={{color: pathname === '/shops' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                 borderColor: pathname === '/shops' ? sellerPrimaryColor1 : sellerPrimaryColor2}}>
//                                                 All {sellerProductPluralTerm} 
//                                             </Link>
//                                         </li>
//                                         <li>
//                                             <span onClick={redirect_customerDashboard_page} 
//                                                 className='hover:border-b-2 pl-2 pr-2 pb-1 cursor-pointer'
//                                                 style={{color: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                 borderColor: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2}}>
//                                                 My Dashboard
//                                             </span>
//                                         </li>
//                                         <li className={` ${sellerBoolShowGalleryImages ? '' : 'hidden'} `}>
//                                             <Link to='/galleryImages' className='hover:border-b-2 pl-2 pr-2 pb-1' 
//                                                 style={{color: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                     borderColor: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2 }} >
//                                                 Gallery
//                                             </Link>
//                                         </li>
//                                         <li>
//                                             <Link to='/aboutUs' className='hover:border-b-2 pl-2 pr-2 pb-1' 
//                                                 style={{color: pathname === '/aboutUs' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                     borderColor: pathname === '/aboutUs' ? sellerPrimaryColor1 : sellerPrimaryColor2 }} >
//                                                 About Us
//                                             </Link>
//                                         </li>
//                                         <li className='hidden'>
//                                             <Link className='hover:border-b-2 p-2' 
//                                                 style={{color: pathname === '/contact' ? sellerPrimaryColor1 : sellerPrimaryColor2, 
//                                                 borderColor: pathname === '/contact' ? sellerPrimaryColor1 : sellerPrimaryColor2 }} >
//                                                 Contact Us 
//                                             </Link>
//                                         </li>    
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                         { /*md:lg:w-full w-3/12 border*/ }
//                         <div className='md:lg:w-full w-2/12 border-none'>
//                             <div className='flex md-lg:hidden justify-center items-center'>
//                                 <div className='flex justify-center gap-5' 
//                                     style={{borderColor:sellerPrimaryColor1}}>
//                                     <div onClick={redirect_wishlist_page} style={{backgroundColor:sellerSecondaryColor1}}
//                                         className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
//                                         relative flex justify-center items-center cursor-pointer rounded-full w-[65px] h-[35px]  `}>
//                                         <span className='text-xl pr-1' style={{color:sellerPrimaryColor1}}>
//                                             <MdOutlineRestaurantMenu/>
//                                         </span>
//                                         <span className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                             <FaHeart />
//                                         </span>
//                                         {
//                                             wishlist_count !== 0 && 
//                                             <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex 
//                                                 justify-center items-center -top-[8px] -right-[16px] '>
//                                                 {wishlist_count}
//                                             </div>
//                                         }        
//                                     </div>
                                    
//                                     <div onClick={redirect_cart_page}
//                                         className='relative flex justify-center items-center cursor-pointer whitespace-nowrap 
//                                         w-[65px] h-[35px] rounded-full' style={{backgroundColor:sellerSecondaryColor1}}>
//                                         <span className='text-xl pr-1' style={{color:sellerPrimaryColor1}}>
//                                             <MdOutlineRestaurantMenu/> 
//                                         </span>
//                                         <span className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                             <FaCartShopping />
//                                         </span>
//                                         {
//                                             //-right-[5px]
//                                             cart_product_count !== 0 && 
//                                             <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex 
//                                                 justify-center items-center -top-[8px] -right-[16px] '>
//                                                 { cart_product_count }
//                                             </div>
//                                         }
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className='hidden md-lg:block'>
//                 <div onClick={()=> setShowSidebar(true)} 
//                     className={`fixed transition-all duration-2000 ease-in-out delay-200 
//                         ${showSidebar ? 'invisible' : 'visible'} hidden md-lg:block w-screen h-screen 
//                         bg-[rgba(0,0,0,0.5)] top-0 left-0 z-20 `}>
//                 </div>
//                 <div id='sideMenuMobile' className={`w-[300px] z-[9999] transition-all duration-2000 ease-in-out delay-200 fixed 
//                     ${showSidebar ? '-left-[300px]' : 'left-0 top-0'} overflow-y-auto bg-white h-screen py-6 px-8 `}>
//                     <div className='flex justify-start flex-col gap-6'>
//                         <table className='w-full'>
//                             <tbody>
//                                 <tr>
//                                     <td>
//                                         <Link to='/'>
//                                             <img className='mb-1' src={sellerCompanyLogo} alt="Mylogopng" />
//                                         </Link>
//                                     </td>
//                                     <td valign='top' className='' >  
//                                         <div onClick={() => setShowSidebar(!showSidebar)} 
//                                             className='justify-center items-center w-[30px] h-[30px] rounded-lg
//                                             cursor-pointer lg:hidden md-lg:flex xl:hidden hidden border text-red-600 text-[18px]' 
//                                             style={{borderColor:sellerPrimaryColor1}}>
//                                             <span><IoMdClose /></span>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                         <div className='hidden justify-between items-center'>
//                             <Link to='/'>
//                                 <img src={sellerCompanyLogo} alt="mylogopng" />
//                             </Link>
//                             <div onClick={() => setShowSidebar(false)} 
//                                 className='justify-center items-center w-[30px] h-[30px] rounded-lg 
//                                 cursor-pointer lg:hidden md-lg:flex xl:hidden hidden border'
//                                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                 <span><FaList/></span>
//                             </div>
//                         </div>
//                         <div className='flex justify-start items-center gap-7'>
//                             { /*before:w-[1px] <div>{sellerCompanyKosherSupervision1}</div> */ }
//                             <div className={`flex cursor-pointer text-sm justify-center items-center gap-1 relative after:h-[18px]  
//                                 after:-right-[10px] after:absolute before:absolute before:h-[10px] text-slate-800 font-bold 
//                                 after:bg-[#afafaf] before:bg-[#afafaf] after:w-[1px] before:-left-[18px]`}>
//                                 <div className='font-bold' style={{color:sellerPrimaryColor1}}>
//                                     <div>Kosher</div>
//                                     <span className={`${sellerCompanyKosherSupervision1 === 'None' ? 'hidden' : 'font-bold'} `}>{sellerCompanyKosherSupervision1}</span>
//                                     <span className={`${sellerCompanyKosherSupervision2 === 'None' ? 'hidden' : 'font-bold'} `}> {sellerCompanyKosherSupervision2}</span>
//                                 </div>
//                                 <img className='hidden' src={`/images/kashrus/OU-Kosher-logo-20x20.png`} alt='' />
//                             </div>
//                             <div className='hidden group cursor-pointer text-slate-800 text-sm justify-center items-center gap-1 relative after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px] after:absolute '>
//                                 <img src={sellerFrontEndURL + `/images/language.png`} alt="" />
//                                 <span><IoMdArrowDropdown /></span>
//                                 <ul className='absolute invisible transition-all top-12 rounded-sm duration-200 text-white p-2 w-[100px] flex flex-col gap-3 group-hover:visible group-hover:top-6 group-hover:bg-black z-10'>
//                                     <li>Hindi</li>
//                                     <li>English</li>
//                                 </ul>
//                             </div>
//                             {
//                                 //flex cursor-pointer justify-center items-center gap-1
//                                 //flex border border-green-200 w-full cursor-pointer justify-center items-center gap-1
//                                 userInfo ? 
//                                     <div className='grid grid-cols-3 gap-2 border-none  '>
//                                         <div className='border p-1 rounded-lg' style={{ borderColor:sellerPrimaryColor1}}>
//                                             <IoChatbubbleEllipsesOutline className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                                 text-green-500 bg-white text-[28px]`} onClick={redirect_chat_page} />
//                                         </div>
//                                         <div className='border p-1 rounded-lg' style={{ borderColor:sellerPrimaryColor1}}>
//                                             <AiOutlineDashboard onClick={redirect_customerDashboard_page} 
//                                                 className='text-green-500 text-[28px]'/>
//                                         </div>
//                                         <div className='border p-1 rounded-lg' style={{ borderColor:sellerPrimaryColor1}}>
//                                             <IoMdLogOut onClick={logout} className='text-red-600 text-[28px]' />
//                                         </div>

//                                         <div className='hidden text-[12px] p-1 text-black font-semibold rounded-lg bg-green-200 border border-green-200'>
//                                         { 
//                                             eventDetails?.eventName === '' ?
//                                             <span onClick={redirect_customerDashboard_page} 
//                                                 className='text-[13px] p-1 pl-0 pr-2 text-blue-800 font-semibold 
//                                                 rounded-lg bg-green-200 border border-green-200'>
//                                                 {userInfo?.name}<br />{userInfo?.email}
//                                             </span>
//                                             :
//                                             <span 
//                                                 className='text-[13px] p-1 text-blue-800 font-semibold 
//                                                 rounded-lg bg-green-200 border border-green-200 leading-4 '>
//                                                 {userInfo?.email}<br />{eventDetails?.eventName}
//                                             </span>
//                                         }   
//                                         </div>
//                                     </div> 
//                                     : 
//                                     <Link to='/login' className='flex cursor-pointer justify-center items-center gap-0.5 text-sm text-green-600'>
//                                         <span><IoMdLogIn size={20} /></span>
//                                         <span>Login</span>
//                                     </Link>
//                             } 
//                         </div>  
//                         { /*flex*/ }
//                         <div className='hidden justify-left gap-5'>
//                             <div className='relative flex justify-center items-center cursor-pointer rounded-full 
//                                 w-[65px] h-[35px]' style={{backgroundColor:sellerSecondaryColor1}}>
//                                 <span onClick={redirect_cart_page} className='text-xl pr-1' style={{color:sellerPrimaryColor1}}>
//                                     <MdOutlineRestaurantMenu/>
//                                 </span>
//                                 <span className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                     <FaHeart />
//                                 </span>
//                                 <div className='w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white 
//                                     flex justify-center items-center -top-[3px] -right-[12px] '>
//                                     { /*wishlist_count*/}
//                                 </div>
//                             </div>
//                             <div className='relative flex justify-center items-center cursor-pointer whitespace-nowrap 
//                                 w-[65px] h-[35px] rounded-full' style={{backgroundColor:sellerSecondaryColor1}}>
//                                 <span onClick={redirect_cart_page} className='text-xl pr-1' style={{color:sellerPrimaryColor1}}>
//                                     <MdOutlineRestaurantMenu/> 
//                                 </span>
//                                 <span onClick={redirect_cart_page} className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                     <FaCartShopping />
//                                 </span>
//                                 {
//                                     //-right-[5px]
//                                     cart_product_count !== 0 && 
//                                     <div className='w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex 
//                                         justify-center items-center -top-[3px] -right-[12px] '>
//                                         { cart_product_count }
//                                     </div>
//                                 }
//                             </div>
//                         </div>
//                         <div className={` ${userInfo ? '' : 'hidden'} flex tracking-widest border-none`} 
//                             style={{color:sellerPrimaryColor1}}>
//                             { 
//                                 eventDetails?.eventName === '' ?
//                                 <span 
//                                     className='w-full text-[13px] p-1 text-blue-800 font-semibold 
//                                     bg-green-200 border border-blue-800'>
//                                     <div className='pl-2 pt-1'>{userInfo?.name}</div>
//                                     <div className='pl-2 pb-1'>{userInfo?.email}</div>
//                                 </span>
//                                 :
//                                 <div  
//                                     className='w-full text-[13px] text-blue-800 font-semibold 
//                                     bg-green-200 border border-blue-800'>
//                                     <div className='pl-2 pt-1'>{userInfo?.email}</div>
//                                     <div className='pl-2 pb-1'>{eventDetails?.eventName}</div>
//                                 </div>
//                             }
//                         </div>
//                         <div className={`w-full p-1 flex justify-center items-center uppercase font-bold tracking-widest border`}
//                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             {sellerTaglineTop1}
//                         </div>
//                         <ul className='flex flex-col justify-start items-start text-sm font-bold uppercase'>
//                             <li>
//                                 <Link to='/' className='p-2 block' style={{color: pathname === '/' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     Home
//                                 </Link>
//                             </li>
//                             <li>
//                                 <Link to='/shops' className='p-2 block' 
//                                     style={{color: pathname === '/shops' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     All {sellerProductPluralTerm}
//                                 </Link>
//                             </li>
//                             <li>
//                                 <span onClick={redirect_customerDashboard_page} className='p-2 block cursor-pointer'
//                                     style={{color: pathname === '/customerDashboard' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     My Dashboard
//                                 </span>
//                             </li>
//                             <li className={` ${sellerBoolShowGalleryImages ? '' : 'hidden'} `}>
//                                 <Link to='/galleryImages' className='p-2 block' 
//                                     style={{color: pathname === '/galleryImages' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>
//                                     Gallery
//                                 </Link>
//                             </li>
//                             <li>
//                                 <Link to='/aboutUs' className='p-2 block' style={{color: pathname === '/about' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}> 
//                                     About Us
//                                 </Link>
//                             </li>
//                             <li className='hidden' >
//                                 <Link to='/contact' className='p-2 block' style={{color: pathname === '/contact' ? sellerPrimaryColor1 : sellerPrimaryColor2 }}>                                            
//                                     Contact Us
//                                 </Link>
//                             </li>
//                             <li className={` ${sellerOtherWebsiteURL1 === '' ? 'hidden' : '' }  `}>
//                                 <span>
//                                     <Link className='p-2 block' target="_blank" to={`${sellerOtherWebsiteURL1}`}>
//                                         {sellerOtherWebsiteName1}
//                                     </Link>
//                                 </span>
//                             </li>
//                         </ul>
//                         <div className='hidden justify-start items-center gap-4 text-black'>
//                             <a href="#"><FaFacebookF /></a>
//                             <a href="#"><FaTwitter /> </a>
//                             <a href="#"><FaLinkedin /></a>
//                             <a href="#"><FaGithub /> </a> 
//                         </div>  
//                         <div className='w-full flex justify-end md-lg:justify-start gap-3 items-center'>
//                             <div className='w-[48px] h-[48px] rounded-full flex bg-[#f5f5f5] justify-center items-center '>
//                                 <span style={{color:sellerPrimaryColor2}}><FaPhoneAlt /></span>
//                             </div>
//                             <div className='flex justify-end flex-col gap-1'>
//                                 <h2 className='text-sm font-medium' style={{color:sellerPrimaryColor2}}>{sellerCompanyPhoneNumber}</h2>
//                                 <span className='text-xs' style={{color:sellerPrimaryColor2}}>Call Us!!</span> 
//                             </div>
//                         </div>
//                         <ul className='flex flex-col justify-start items-start gap-3' style={{color:sellerPrimaryColor2}}>
//                             <li className='flex justify-start items-center gap-2 text-sm'>
//                                 <span><MdEmail /></span>
//                                 <span>{sellerCompanyEmailAddress}</span>
//                             </li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//             <div className='w-[85%] lg:w-[90%] mx-auto'>
//                 <div className='flex w-full flex-wrap md-lg:gap-8'>
//                     <div className='w-3/12 md-lg:w-full'>
//                         <div className='hidden'>set to  hidden extend the plian drop downs and seach all the way acros</div>
//                         <div className='bg-white relative'>
//                             <div onClick={() => setCategoryShow(!categoryShow) } 
//                                 className={`h-[40px] flex justify-center md-lg:justify-between md-lg:px-6 items-center gap-3 
//                                 font-bold text-md cursor-pointer text-white`} 
//                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                 <div className='flex justify-center items-center gap-2'>
//                                     <span><FaList/></span>
//                                     <span>All Categories</span>
//                                 </div>
//                                 <span className='pt-1'><IoIosArrowDown /></span>
//                             </div>
//                             <div className={`${categoryShow ? 'h-0' : 'h-[300px]'} 
//                                 overflow-y-scroll transition-all md-lg:relative duration-500 absolute z-[99999] w-full border-x`}
//                                 style={{backgroundColor:sellerSecondaryColor1}}>
//                                 <ul className='py-2 font-medium'>
//                                     {
//                                         categorys.map((c,i) => {
//                                             return (
//                                                 <li key={i} className={`flex justify-start items-center gap-2 px-[24px] py-[6px]`}>
//                                                     <img src={c.image} alt=""
//                                                         className={`w-[30px] h-[30px] rounded-full overflow-hidden`} />
//                                                     <Link onClick={() => setCategoryShow(!categoryShow) } 
//                                                         to={`/productsCategory?category=${c.name}`} className='text-sm block' 
//                                                         style={{color:sellerPrimaryColor1}}>{c.name}</Link>
//                                                 </li>
//                                             )
//                                         })
//                                     }
//                                 </ul>
//                             </div>

//                             <div onClick={() => setMainIngredientShow(!mainIngredientShow) } 
//                                 className={`h-[40px] mt-1 flex justify-center md-lg:justify-between md-lg:px-6 items-center gap-3 font-bold text-md cursor-pointer 
//                                 text-white`} style={{backgroundColor:sellerPrimaryColor1}}>
//                                 <div className='flex justify-center items-center gap-2'>
//                                     <span><FaList/></span>
//                                     <span>All {sellerMainIngredientPluralTerm}</span>
//                                 </div>
//                                 <span className='pt-1'><IoIosArrowDown /></span>
//                             </div>
//                             <div className={`${mainIngredientShow ? 'h-0' : 'h-[300px]'} 
//                                 overflow-y-scroll transition-all md-lg:relative duration-500 absolute z-[99990]  w-full border-x`} 
//                                 style={{backgroundColor:sellerSecondaryColor1}}>
//                                 <ul className='py-2 font-medium'>
//                                     {
//                                         mainIngredients.map((c,i) => {
//                                             return (
//                                             <li key={i} className={` flex justify-start items-center gap-2 px-[24px] py-[6px] `}>
//                                                 <img src={c.image} className='hidden w-[30px] h-[30px] rounded-full overflow-hidden' alt="" />
//                                                 <img src={c.image} alt=""
//                                                     className={`w-[30px] h-[30px] rounded-full overflow-hidden`} />
//                                                 <Link onClick={() => setMainIngredientShow(!mainIngredientShow) } 
//                                                     to={`/productsMainIngredient?mainIngredient=${c.name}`} className='text-sm block' 
//                                                     style={{color:sellerPrimaryColor1}}>{c.name}</Link>
//                                             </li>
//                                             )
//                                         })
//                                     }
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                     <div id='MiddleSecondRowSectionGood' className='w-9/12 pl-3 md-lg:pl-0 md-lg:w-full'>
//                         <div className='flex flex-wrap w-full justify-between items-center md-lg:gap-6'>
//                             <div className='w-9/12 md-lg:w-full'>
                                
//                                 <div className={`sm:inline-block md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden
//                                     border w-full h-[54px] mb-1 text-lg flex 
//                                     text-center items-center justify-center uppercase font-bold tracking-widest`} 
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     {sellerTaglineTop1}
//                                 </div>
                                
//                                 <div className={`sm:hidden 
//                                     border w-full h-[40px] mb-1 p-2 text-lg flex border-[#dbf3ed] 
//                                     text-center items-center justify-center uppercase font-bold tracking-widest`} 
//                                     style={{color:sellerPrimaryColor1}}>
//                                     {sellerTaglineTop1}
//                                 </div>
                                
//                                 <div className='flex border-none h-[40px] items-center relative gap-6'>
//                                     <div className='hidden relative after:absolute after:h-[25px] after:w-[1px] after:bg-[#afafaf] 
//                                         after:-right-[15px] md:hidden'>
//                                         <select onChange={(e) => setCategory(e.target.value)} name="" id="" 
//                                             className='w-[140px] border font-semibold text-sm bg-transparent outline-0' 
//                                             style={{color:sellerPrimaryColor1}}>
//                                             <option value="">Categories</option>
//                                             {
//                                                 categorys.map((c, i) => 
//                                                     <option key={i} value={c.name} className={`text-sm block`}>{c.name}</option>
//                                                 )
//                                             }
//                                         </select>
//                                     </div>
//                                     <div className='hidden relative after:absolute after:h-[25px] after:w-[1px] after:bg-[#afafaf] 
//                                         after:-right-[15px] md:hidden'>
//                                         <select onChange={(e) => setMainIngredient(e.target.value)} name="" id="" 
//                                             className='w-[140px] border font-semibold text-sm bg-transparent outline-0' 
//                                             style={{color:sellerPrimaryColor1}}>
//                                             <option value="">{sellerMainIngredientPluralTerm}</option>
//                                             {
//                                                 mainIngredients.map((c, i) => 
//                                                     <option key={i} value={c.name} className={`text-sm block`}>{c.name}</option>
//                                                 )
//                                             }
//                                         </select>
//                                     </div>
//                                     {
//                                         //onChange={(e) => setMyReview(e.target.value)}
//                                         // <input onChange={(e)=> setSearchValue(e.target.value)} type="text" name='' id='' placeholder='Search' 
//                                         // className='w-full border rounded-l-lg relative bg-transparent text-slate-500 outline-0 px-3 h-full' />

//                                     }
//                                     <input onChange={(e)=> searchValueLocal(e.target.value)} value={searchValue} onKeyDown={handleKeyDown} type="text" name='' id='' placeholder='Menu Search' 
//                                         className='w-full border rounded-l-lg relative bg-transparent text-slate-500 outline-0 px-3 h-full' />
//                                     <button onClick={search} className='right-0 absolute rounded-r-lg px-2 w-[80px] h-full font-semibold uppercase text-white' style={{backgroundColor:sellerPrimaryColor1}}>
//                                         Search
//                                     </button>
//                                 </div>
//                             </div>

//                             <div className='w-3/12 block md-lg:hidden pl-3 md-lg:w-full md-lg:pl-0'>
//                                 <div className='w-full border-none flex justify-end md-lg:justify-start gap-1 items-center'>
//                                     <div>
//                                         <div className='w-[70px] h-[70px] rounded-full flex justify-center items-center border-none' 
//                                              style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1}}>
//                                             <span><FaPhoneAlt className='hidden' /></span>
//                                             <span><MdOutlineRestaurantMenu className='text-[46px]' /></span>                                       
//                                         </div>
//                                     </div>
                                    
//                                     <div className='flex justify-end flex-col gap-1'>
//                                         <div className='hidden text-[12px] p-1 font-medium pr-2' style={{color:sellerPrimaryColor1}}>
//                                             343-432-1234<br/>Menu Questions<br/> 
//                                             718 781-4207<br/>Tech Support
//                                         </div> 
//                                         <div className='text-[12px] border-none leading-5' 
//                                             style={{color:sellerPrimaryColor1}}>
//                                             {sellerMarketingLine1}
//                                         </div>
//                                     </div>
//                                 </div>                   
//                             </div>
//                         </div>
//                     </div>
//                     {
//                     //sm:inline-block md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden
//                     //h-[64px] md:h-[70px] 
//                     }
//                     <div className={`w-full sm:hidden p-2 text-2xl my-1 mb-2 flex justify-center items-center 
//                         uppercase text-center font-bold tracking-widest border border-[#dbf3ed]  `} 
//                         style={{color:sellerPrimaryColor1}}>
//                         {sellerTaglineTop2}
//                     </div>
//                     <div className={` ${personalServiceTagLine === '' ? 'hidden' : ''} 
//                         w-full sm:hidden p-1 text-md my-1 mb-2 flex justify-center items-center 
//                         uppercase text-center font-semibold tracking-widest border border-[#dbf3ed]  `} 
//                         style={{color:sellerPrimaryColor1}}>
//                         {personalServiceTagLine}
//                     </div>
//                     <div className={` ${sellerHolidayHeader === 'None' ? 'hidden' : ''} 
//                         w-full text-center items-center justify-center justify-items-center `}>
//                         {
//                             // 4xl:text-4xl md-lg:text-3xl md:text-2xl sm:text-2xl xs:text-2xl 
//                             // 2xs:text-2xl 3xs:text-2xl 3xs:text-2xl 4xs:text-2xl text-2xl
//                         }
//                         <a className='2xs:text-[16px] xs:text-[16px] sm:text-[16px] md:text-md md-lg:text-md 
//                             lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl 4xl:text-2xl 
//                             flex curser-pointer hover:underline text-white rounded-xl border py-1 px-3 
//                             justify-center items-center' 
//                             href={`/shops/${sellerHolidayHeader}`} rel="noreferrer"
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             <MdOutlineRestaurantMenu className='mr-1 inline-block' /> Check Out Our {sellerHolidayHeader} Menu
//                         </a>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Header;




